import type { Icon } from 'ngxi'

export const nrk360: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.083 8.212C4.561 8.974 4 9.84 4 10.5s.56 1.526 2.083 2.288C7.546 13.518 9.636 14 12 14h.58l-2.1-3h2.44l2.8 4l-2.8 4h-2.44l2.1-3H12c-2.607 0-5.016-.526-6.811-1.424C3.454 13.71 2 12.326 2 10.5s1.454-3.209 3.189-4.076C6.984 5.526 9.393 5 12 5s5.016.526 6.811 1.424C20.546 7.29 22 8.674 22 10.5c0 1.441-.92 2.613-2.118 3.446a9 9 0 0 1-1.464.817l-1.172-1.675a7.5 7.5 0 0 0 1.494-.784c.927-.645 1.26-1.286 1.26-1.804c0-.66-.56-1.526-2.083-2.288C16.454 7.482 14.364 7 12 7s-4.454.481-5.917 1.212\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrk404: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m9.592 8.277l-.898-1.384l3.46-2.247l.898 1.384zm-.485 2.282l-.899-1.384l-.898-1.384l-.9-1.383l1.385-.9l3.46-2.246l1.383-.899l.9 1.384l.898 1.384l.899 1.384l-1.384.899l-3.46 2.247zm4.47 4.063l1.697.865l-.1-1.903l-.188-3.61l-.1-1.902l-1.598 1.038l-3.032 1.968l-1.598 1.038l1.698.865zm-.1-1.903l-.09-1.707l-1.433.931zm4.258-.755h2.475v8.251h-2.475zm4.125-1.65v11.551h-5.775v-11.55zm-13.652.698l-3.76 10.922l-1.56-.537l3.76-10.922zm2.513 9.203a2.063 2.063 0 1 0 0-4.125a2.063 2.063 0 0 0 0 4.125m3.713-2.063a3.713 3.713 0 1 1-7.425 0a3.713 3.713 0 0 1 7.425 0\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkAlarmClock: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"m2.177.63l-1.5 1.5l1.414 1.414l1.5-1.5zM11 12.414V6h2v5.586l3.707 3.707l-1.414 1.414z\"/><path fill-rule=\"evenodd\" d=\"M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11c0 2.678-.958 5.13-2.549 7.037L23 21.586L21.586 23l-2.549-2.549A10.95 10.95 0 0 1 12 23c-2.678 0-5.13-.958-7.037-2.549L2.414 23L1 21.586l2.549-2.549A10.95 10.95 0 0 1 1 12m11-9a9 9 0 1 0 0 18a9 9 0 0 0 0-18\" clip-rule=\"evenodd\"/><path d=\"M20.421 2.044L21.835.63l1.5 1.5l-1.414 1.414z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkArrangeList: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 8h20v2H2zm20 6H2v2h20z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkArrowDown: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m12 20l-7-4.9v-2.27l6 4.2V4l2 1v12.03l6-4.2v2.27z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkArrowDropdown: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m12 15l5-5H7z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkArrowLeft: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m4 12l4.9-7h2.272l-4.2 6H20l-1 2H6.972l4.2 6H8.9z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkArrowLeftLong: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m4 12l4.9-7h2.272l-4.2 6H36l-1 2H6.972l4.2 6H8.9z\" clip-rule=\"evenodd\"/>",
  "width": 40,
  "height": 24,
  "viewBox": "0 0 40 24"
}

export const nrkArrowNested: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M17 4H2v2h13v11.08l-5-3.25v2.272l6 3.9l6-3.9V13.83l-5 3.25z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkArrowRight: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m20.002 12l-4.9-7H12.83l4.2 6H5l-1 2h13.03l-4.2 6h2.272z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkArrowRightLong: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m36 12l-4.9-7h-2.272l4.2 6H4l1 2h28.028l-4.2 6H31.1z\" clip-rule=\"evenodd\"/>",
  "width": 40,
  "height": 24,
  "viewBox": "0 0 40 24"
}

export const nrkArrowUp: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m12 4l7 4.9v2.27l-6-4.2V20l-2-1V6.97l-6 4.2V8.9z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkArticle: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5 3h14v18H5zM3 23V1h18v22zm4-11v2h8v-2zm0-6h4v2H7zm6 10H7v2h6z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkBack: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4.4 7.4L6.8 4h2.5L7.2 7h6.3a6.5 6.5 0 0 1 0 13H9l1-2h3.5a4.5 4.5 0 1 0 0-9H7.2l2.1 3H6.8L4.4 8.6L4 8z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkBell: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13 1h-2v1.055C7.863 2.4 5 4.382 5 8v8.5L3 18v2h18v-2l-2-1.5V8c0-3.618-2.863-5.6-6-5.945zm1 20h-4a2 2 0 1 0 4 0M11.997 4h.006C13.4 4 14.7 4.405 15.6 5.09C16.445 5.736 17 6.66 17 8v9.5l.667.5H6.333L7 17.5V8c0-1.34.555-2.265 1.4-2.91C9.3 4.406 10.599 4 11.997 4\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkBellActive: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13 1h-2v1.055C7.863 2.4 5 4.382 5 8v8.5L3 18v2h18v-2l-2-1.5V8c0-3.618-2.863-5.6-6-5.945zm1 20h-4a2 2 0 1 0 4 0\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkBookmark: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m12 17.542l1.163.83L17 21.115V3H7v18.114l3.838-2.741zm-7 4.729l1.894 1.376l.106-.076L12 20l5 3.571l.108.078L19 22.274V1H5z\" clip-rule=\"evenodd\"/><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M17 7H7V5h10z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkBookmarkActive: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6.894 23.647L5 22.271V1h14v21.275l-1.892 1.374L12 20zM7 5h10V3H7z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkBroadcast: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.869 9.699L6.929 2h-2.37L.5 9.699L4.35 17h2.369zm4.733 0L10.08 5H7.71L5.234 9.699L7.501 14h2.37zm13.525 0L17.067 2h2.37l4.06 7.699L19.646 17h-2.37zm-4.733 0L13.916 5h2.37l2.477 4.699L16.495 14h-2.37zM13.107 22v-8H11v8z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkBulletSquare: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8 8h8v8H8z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkBulletedList: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6 11h16v2H6zm16 6H6v2h16zM6 5h16v2H6zm-4 6h2v2H2zm2 6H2v2h2zM2 5h2v2H2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkCalendar: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6 1h2v2h8V1h2v2h4v19H2V3h4zM4 20V7h16v13zM8 9H6v2h2zm2 0h2v2h-2zm-2 4H6v2h2z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkCategory: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4 4h5v5H4zm-2 7V2h9v9zm2 4h5v5H4zm-2 7v-9h9v9zM20 4h-5v5h5zm-7-2v9h9V2zm2 13h5v5h-5zm-2 7v-9h9v9z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkCategoryActive: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 11V2h9v9zm0 2h9v9H2zM13 2v9h9V2zm0 20v-9h9v9z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkCheck: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M19.707 7.707L9.305 18.11l-4.882-5.634l1.511-1.31l3.476 4.01l8.883-8.883z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkCheckActive: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12S5.925 1 12 1s11 4.925 11 11M9.305 18.11l9.402-9.403l-1.414-1.414l-7.883 7.883l-2.476-3.01l-1.511 1.31l3.882 4.633z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkCheckRadioUnchecked: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12 19a7 7 0 1 0 0-14a7 7 0 0 0 0 14m0 2a9 9 0 1 0 0-18a9 9 0 0 0 0 18\" clip-rule=\"evenodd\" opacity=\".5\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkCheckbox: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M20 4H4v16h16zm-2 2H6v12h12z\" clip-rule=\"evenodd\" opacity=\".5\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkCheckboxActive: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3 21V3h18v18zm6.95-4.03l8.26-8.26l-1.41-1.42l-6.74 6.74L7.5 11.1L6 12.4z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkChevronDown: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m4 10.88l8 5.6l8-5.6V9l-8 5.6L4 9z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkChevronLeft: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m13.12 4l-5.6 8l5.6 8H15l-5.6-8L15 4z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkChevronRight: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m10.88 4l5.6 8l-5.6 8H9l5.6-8L9 4z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkChevronUp: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m4 13.12l8-5.6l8 5.6V15l-8-5.6L4 15z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkClock: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M13 11.586V6h-2v6.414l4.293 4.293l1.414-1.414z\"/><path fill-rule=\"evenodd\" d=\"M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1S1 5.925 1 12s4.925 11 11 11m0-2a9 9 0 1 1 0-18a9 9 0 0 1 0 18\" clip-rule=\"evenodd\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkClose: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m12 10.586l6.293-6.293l1.414 1.414L13.414 12l6.293 6.293l-1.414 1.414L12 13.414l-6.293 6.293l-1.414-1.414L10.586 12L4.293 5.707l1.414-1.414z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkCloseActive: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1S1 5.925 1 12s4.925 11 11 11m-1.414-11l-3.293 3.293l1.414 1.414L12 13.414l3.293 3.293l1.414-1.414L13.414 12l3.293-3.293l-1.414-1.414L12 10.586L8.707 7.293L7.293 8.707z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkComment: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1 3h22v17h-7.708l1.528 3h-2.245l-1.528-3H1zm20 15V5H3v13zM5 7h6v2H5z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkDialogue: Icon = {
  "body": "<g fill=\"currentColor\" fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path d=\"M23 12H6v7h12l2 3h2l-2-3h3z\"/><path d=\"M1 9V2h17v7H6l-2 3H2l2-3zm2-2V4h13v3z\" opacity=\".5\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkDice1: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M14 12a2 2 0 1 1-3.999.001A2 2 0 0 1 14 12\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkDice1Active: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M22 2H2v20h20zM12 14a2 2 0 1 0 .001-3.999A2 2 0 0 0 12 14\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkDice2: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8 6a2 2 0 1 1-3.999.001A2 2 0 0 1 8 6m12 12a2 2 0 1 1-3.999.001A2 2 0 0 1 20 18\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkDice2Active: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M22 2H2v20h20zM6 8a2 2 0 1 0 .001-3.999A2 2 0 0 0 6 8m12 12a2 2 0 1 0 .001-3.999A2 2 0 0 0 18 20\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkDice3: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8 6a2 2 0 1 1-3.999.001A2 2 0 0 1 8 6m6 6a2 2 0 1 1-3.999.001A2 2 0 0 1 14 12m6 6a2 2 0 1 1-3.999.001A2 2 0 0 1 20 18\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkDice3Active: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M22 2H2v20h20zM8 6a2 2 0 1 1-3.999.001A2 2 0 0 1 8 6m6 6a2 2 0 1 1-3.999.001A2 2 0 0 1 14 12m4 8a2 2 0 1 0 .001-3.999A2 2 0 0 0 18 20\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkDice4: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8 6a2 2 0 1 1-3.999.001A2 2 0 0 1 8 6m0 12a2 2 0 1 1-3.999.001A2 2 0 0 1 8 18M20 6a2 2 0 1 1-3.999.001A2 2 0 0 1 20 6m0 12a2 2 0 1 1-3.999.001A2 2 0 0 1 20 18\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkDice4Active: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M22 2H2v20h20zM6 8a2 2 0 1 0 .001-3.999A2 2 0 0 0 6 8m0 12a2 2 0 1 0 .001-3.999A2 2 0 0 0 6 20M20 6a2 2 0 1 1-3.999.001A2 2 0 0 1 20 6m-2 14a2 2 0 1 0 .001-3.999A2 2 0 0 0 18 20\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkDice5: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8 6a2 2 0 1 1-3.999.001A2 2 0 0 1 8 6m0 12a2 2 0 1 1-3.999.001A2 2 0 0 1 8 18m6-6a2 2 0 1 1-3.999.001A2 2 0 0 1 14 12m6-6a2 2 0 1 1-3.999.001A2 2 0 0 1 20 6m0 12a2 2 0 1 1-3.999.001A2 2 0 0 1 20 18\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkDice5Active: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M22 2H2v20h20zM8 6a2 2 0 1 1-3.999.001A2 2 0 0 1 8 6m0 12a2 2 0 1 1-3.999.001A2 2 0 0 1 8 18m4-4a2 2 0 1 0 .001-3.999A2 2 0 0 0 12 14m8-8a2 2 0 1 1-3.999.001A2 2 0 0 1 20 6m-2 14a2 2 0 1 0 .001-3.999A2 2 0 0 0 18 20\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkDice6: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8 6a2 2 0 1 1-3.999.001A2 2 0 0 1 8 6m0 6a2 2 0 1 1-3.999.001A2 2 0 0 1 8 12m0 6a2 2 0 1 1-3.999.001A2 2 0 0 1 8 18M20 6a2 2 0 1 1-3.999.001A2 2 0 0 1 20 6m0 6a2 2 0 1 1-3.999.001A2 2 0 0 1 20 12m0 6a2 2 0 1 1-3.999.001A2 2 0 0 1 20 18\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkDice6Active: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M22 2H2v20h20zM6 8a2 2 0 1 0 .001-3.999A2 2 0 0 0 6 8m0 6a2 2 0 1 0 .001-3.999A2 2 0 0 0 6 14m2 4a2 2 0 1 1-3.999.001A2 2 0 0 1 8 18M18 8a2 2 0 1 0 .001-3.999A2 2 0 0 0 18 8m2 4a2 2 0 1 1-3.999.001A2 2 0 0 1 20 12m-2 8a2 2 0 1 0 .001-3.999A2 2 0 0 0 18 20\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkDownload: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M13 2h-2v15.1l-7-4.4V15l8 5l8-5v-2.3l-7 4.4z\"/><path d=\"M4 22h16v2H4z\" opacity=\".5\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkDownloaded: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M4 0h16v2H6v20h12v-8.5l2-2V24H4z\"/><path fill-rule=\"evenodd\" d=\"m22.21 5.7l-8.26 8.27L10 9.4l1.51-1.3l2.55 2.93L20.8 4.3l1.41 1.42Z\" clip-rule=\"evenodd\"/><path d=\"M13.5 19a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkDuration: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1S1 5.925 1 12s4.925 11 11 11m0-2a9 9 0 1 1 0-18a9 9 0 0 1 0 18m1-15v6h-2V6z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkEdit: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M15.9 2L3 14.9v5.7h5.7L21.5 7.7zM7.8 18.5H5v-2.8l7.9-7.9l2.8 2.8zm6.5-12.1l1.6-1.6l2.8 2.8l-1.6 1.6z\"/><path d=\"M12 21h8.6v-2H14z\" opacity=\".5\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkEllipsis: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18 10a2 2 0 1 1 0 4a2 2 0 0 1 0-4m-6 0a2 2 0 1 1 0 4a2 2 0 0 1 0-4m-4 2a2 2 0 1 0-4 0a2 2 0 0 0 4 0\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkEllipsisActive: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M23 12c0-6.075-4.925-11-11-11S1 5.925 1 12s4.925 11 11 11s11-4.925 11-11M6 10a2 2 0 1 1 0 4a2 2 0 0 1 0-4m6 0a2 2 0 1 1 0 4a2 2 0 0 1 0-4m6 0a2 2 0 1 1 0 4a2 2 0 0 1 0-4\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkFullscreen: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12 4h6.586l-5.293 5.293l1.414 1.414L20 5.414V12h2V2H12zM4 18.586l5.293-5.293l1.414 1.414L5.414 20H12v2H2V12h2z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkFullscreenActive: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m16.414 9l6.793-6.793L21.793.793L15 7.586V1h-2v10h10V9zM9 16.414V23h2V13H1v2h6.586L.793 21.793l1.414 1.414z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkGallery: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M21 5H7V3h16v14h-2zm-4 4H3v10h14zM1 7v14h18V7zm14 5.5a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0\" clip-rule=\"evenodd\"/><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.4 14.828L3.228 19H3v-2.6L7.4 12l7 7h-2.83z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkGeo: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11 3.055A9.004 9.004 0 0 0 3.055 11H0v2h3.055A9.004 9.004 0 0 0 11 20.945V24h2v-3.055A9.004 9.004 0 0 0 20.945 13H24v-2h-3.055A9.004 9.004 0 0 0 13 3.055V0h-2zM12 19a7 7 0 1 1 0-14a7 7 0 0 1 0 14m0-3a4 4 0 1 0 0-8a4 4 0 0 0 0 8m0-2a2 2 0 1 1 0-4a2 2 0 0 1 0 4\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkGeoActive: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11 3.055A9.004 9.004 0 0 0 3.055 11H0v2h3.055A9.004 9.004 0 0 0 11 20.945V24h2v-3.055A9.004 9.004 0 0 0 20.945 13H24v-2h-3.055A9.004 9.004 0 0 0 13 3.055V0h-2zM12 16a4 4 0 1 0 0-8a4 4 0 0 0 0 8m0-2a2 2 0 1 1 0-4a2 2 0 0 1 0 4\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkGeopoint: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.455 23h1.101l.994-1.242c1.306-1.632 2.881-3.725 4.137-5.891C18.904 13.767 20 11.305 20 9c0-4.605-3.395-8-8-8S4 4.395 4 9c0 2.293 1.063 4.755 2.271 6.867c1.245 2.177 2.82 4.276 4.177 5.916zM6 9c0 2.95 2.386 6.846 4.712 9.9c.41.54.83 1.047 1.225 1.524L12 20.5q.603-.755 1.247-1.611C15.553 15.823 18 11.949 18 9c0-3.5-2.5-6-6-6S6 5.5 6 9\" clip-rule=\"evenodd\"/><circle cx=\"12\" cy=\"9\" r=\"1\" fill=\"currentColor\"/><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12 11a2 2 0 1 0 0-4a2 2 0 0 0 0 4\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkGeopointActive: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.556 23h-1.1l-1.008-1.217c-1.358-1.64-2.932-3.739-4.177-5.916C5.063 13.755 4 11.293 4 9c0-4.605 3.395-8 8-8s8 3.395 8 8c0 2.305-1.096 4.768-2.313 6.867c-1.256 2.166-2.83 4.258-4.137 5.89zM16 9a4 4 0 1 1-8 0a4 4 0 0 1 8 0\" clip-rule=\"evenodd\"/><path fill=\"currentColor\" d=\"M12 11a2 2 0 1 1 0-4a2 2 0 0 1 0 4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkGlobe: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1 12a11 11 0 1 0 22 0a11 11 0 0 0-22 0m3.58 2.45s-.8-.21-1.34-.37A9 9 0 0 1 3 12l.58-1.28l1.2-.37l-1.2-1.49A9.14 9.14 0 0 1 12.13 3a9.2 9.2 0 0 1 5.19 1.6l-2.36 1.3l-3.79-1.15l-1.46 2.57l1.38-1.24l.71 1.1l-1.68 1.17l-1.56.3l.06.94s-.45.46-.45.66c0 .19.56.56.56.56l1.24-.96l1.2.86l.31-1.6l1.05 3.3l-.8.4l-.92-.44l-.28-.41l-.93.3l-.58.12l-.37.64l-.61.74l-.02.94l.93.85l.65-.07l.67-.15l.43.85l.5.98l-.25.75l.69 1.8l.88-.1l.79-1.1l.93-3.35l-.8-1.59l.7-.8l.9.93l.62-.32l1.35-.97l.63.46l.6 1.1l.94-1.13l.78.16l.68 1.31s.27 0 .36-.13A9.12 9.12 0 0 1 12.14 21a9.17 9.17 0 0 1-6.87-3.07l1.11-2.08l-1.56-.59l-.24-.8z\" clip-rule=\"evenodd\"/><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12 21a9 9 0 1 0 0-18a9 9 0 0 0 0 18m11-9a11 11 0 1 1-22 0a11 11 0 0 1 22 0\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkHardwareCamera: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 5V3h8v2h7v16H1V5zm6 2h7v12H3V7h7V5h4zm0 6a2 2 0 1 1-4 0a2 2 0 0 1 4 0m2 0a4 4 0 1 1-8 0a4 4 0 0 1 8 0\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkHardwareComputer: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M22.005 2H1.995L2 19.006L22.005 19zM4 14.006V3.994L20.005 4L20 14.006zM9 23v-2h6v2zm4-7a1 1 0 1 1-2 0a1 1 0 0 1 2 0\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkHardwareGame: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M23 21h-6l-1-4H8l-1 4H1V3h22zM6.438 15l-1 4H3V5h18v14h-2.438l-1-4zM9 9V7H7v2H5v2h2v2h2v-2h2V9zm6 1a1 1 0 1 0 2 0a1 1 0 0 0-2 0m-2 0a3 3 0 1 0 6 0a3 3 0 0 0-6 0\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkHardwareHeadphones: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2 22V6.667L5.5 2h13L22 6.667V22h-7v-9h5V7.333L17.5 4h-11L4 7.333V13h5v9zm5-7v5H4v-5zm13 5v-5h-3v5z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkHardwareLaptop: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3 16h2L4.995 6h14.01L19 16h2l.005-12H2.995zm-2 2h9v1h4v-1h9v3H1z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkHardwareMicrophone: Icon = {
  "body": "<g fill=\"currentColor\"><path fill-rule=\"evenodd\" d=\"M8 14V2h8v12zm2-10h4v8h-4z\" clip-rule=\"evenodd\"/><path d=\"M6 12H4v6h7v2H8v2h8v-2h-3v-2h7v-6h-2v4H6z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkHardwareMicrophoneActive: Icon = {
  "body": "<g fill=\"currentColor\"><path fill-rule=\"evenodd\" d=\"M8 14V2h8v12z\" clip-rule=\"evenodd\"/><path d=\"M6 12H4v6h7v2H8v2h8v-2h-3v-2h7v-6h-2v4H6z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkHardwareMobile: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5 1h14v22H5zm2 20h10q-.003-9 0-18H7q.003 9 0 18m6.5-3a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkHardwarePrinter: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M18 5V4H6.828L6 4.828V5zM4 4v1H2v14h4v3h12v-3h4V5h-2V2H6zm0 3h16v10h-2v-3H6v3H4zm12 12v1H8v-1zm0-2H8v-1h8zm-8-6.5a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkHardwareRadio: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m6.047 4l1.528-3H9.82L8.291 4H23v16H1V4zM8.5 12a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0m4.5 0a2 2 0 1 0 4 0a2 2 0 0 0-4 0m-2 0a4 4 0 1 0 8 0a4 4 0 0 0-8 0M3 6h18v12H3z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkHardwareSmartSpeaker: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M22 1h2v10h-2zm-2.006 22L20 10.982h-2L17.994 21L6 21.006V4.994L16 5V3L4 2.994v20.012zM17 19.067v.001v-.017c.008.002.004.008.002.013zM12 9.5a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3M20 3h-2v6h2zm-8 14a2 2 0 1 1 0-4a2 2 0 0 1 0 4m0 2a4 4 0 1 1 0-8a4 4 0 0 1 0 8\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkHardwareSmartWatch: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M22 2h2v10h-2zm-4 2h2v6h-2zm-6 4h2v8H6V8zM6 18H4V6h2V2h8v4h2v12h-2v4H6zm2 0v2h4v-2zm4-12H8V4h4zM9 9h1v3h2v1H9z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkHardwareSpeaker: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M20 23.018V.994H4v22.012zM6 3h12v18H6zm6 5.5a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m0 8.5a2 2 0 1 1 0-4a2 2 0 0 1 0 4m0 2a4 4 0 1 1 0-8a4 4 0 0 1 0 8\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkHardwareTablet: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3 1h18v22H3zm2 20h14V3H5zm8.5-3a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkHardwareTv: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.991 3H23.01q-.04 8 0 16H.99q.04-8 0-16m2 14h18.02a603 603 0 0 1 0-12H2.99q.06 6 0 12M18 21H6v2h12z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkHardwareWatch: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M14 4h-4v2h4zM8 4v2H6v12h2v4h8v-4h2V6h-2V2H8zm2 14v2h4v-2zm4-2h2V8H8v8zm-3-7h1v3h2v1h-3z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkHeart: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9 2H5L2 6v7l9 8h2l9-8V6l-3-4h-4l-3 3zm6.828 2L12 7.828L8.172 4H6L4 6.667v5.435L11.76 19h.48L20 12.102V6.667L18 4z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkHeartActive: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 21h-1l-9-8V6l3-4h4l3 3l3-3h4l3 4v7l-9 8z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkHelp: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M21 12a9 9 0 1 1-18 0a9 9 0 0 1 18 0m-9 11c6.075 0 11-4.925 11-11S18.075 1 12 1S1 5.925 1 12s4.925 11 11 11m-.806-9h1.666v-.262q0-.434.245-.854c.245-.42.362-.539.595-.777q.35-.357.7-.735t.595-.896t.245-1.106q0-1.26-.889-1.939q-.89-.68-2.205-.679q-1.526 0-2.436.798T8.8 9.93h1.722q0-.77.42-1.183t1.092-.413q.615 0 .973.308q.357.308.357.91q0 .392-.224.77c-.224.378-.329.485-.539.7q-.315.322-.637.672a3.2 3.2 0 0 0-.546.833q-.225.483-.224 1.029zM12 17.7a1.2 1.2 0 1 0 0-2.4a1.2 1.2 0 0 0 0 2.4\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkHide: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M23.477 20.063h-2.829l-1.967-1.968C16.874 19.25 14.72 20 12 20c-5.096 0-8.204-2.66-10.76-5.654l-.24-.28V9.897l.24-.28c1.373-1.608 2.904-3.106 4.814-4.15L2.586 2h2.828zM7.543 6.957c-1.76.83-3.19 2.139-4.543 3.686v2.678C5.34 16.001 7.907 18 12 18c2.08 0 3.762-.512 5.223-1.363l-2.118-2.118A4 4 0 0 1 8 12a3.99 3.99 0 0 1 1.48-3.104zm3.365 3.365a2 2 0 1 0 2.768 2.768z\" clip-rule=\"evenodd\"/><path d=\"M12 4c5.091 0 8.2 2.619 10.76 5.618l.24.28v4.204l-.24.28q-.493.58-1.019 1.133l-1.418-1.418q.343-.36.677-.74v-2.714c-2.292-2.622-4.807-4.568-8.77-4.64L10.327 4.1Q11.126 4 12 4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkHome: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M23 9.195V6.923L12 1L1 6.923v2.272l11-5.923zM5 11v10h14V11h2v12H3V11z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkHomeActive: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M23 9.195V6.923L12 1L1 6.923v2.272l11-5.923zM3 11l9-4.73L21 11v12H3z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkInfo: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M21 12a9 9 0 1 1-18 0a9 9 0 0 1 18 0m-9 11c6.075 0 11-4.925 11-11S18.075 1 12 1S1 5.925 1 12s4.925 11 11 11m0-13.8a1.2 1.2 0 1 0 0-2.4a1.2 1.2 0 0 0 0 2.4m1 1.8v6h-2v-6z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkLatestNews: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.472 6L2 12l3.472 6H7.5l-3.472-6L7.5 6zM12 13.5a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3M22 12l-3.472-6H16.5l3.472 6l-3.472 6h2.028zM8.315 8L6 12l2.315 4h2.028l-2.315-4l2.314-4zm10.028 4l-2.315-4H14l2.315 4L14 16h2.028z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkLatestNewsActive: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12S5.925 1 12 1s11 4.925 11 11M2 12l3.472-6H7.5l-3.472 6L7.5 18H5.472zm11.5 0a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0m5.028-6L22 12l-3.472 6H16.5l3.472-6L16.5 6zM6 12l2.315-4h2.028l-2.315 4l2.314 4H8.316zm10.028-4l2.315 4l-2.315 4H14l2.315-4L14 8z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkLink: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.59 9.17L3.5 16.24l4.25 4.25l2.83-2.83L12 19.07l-4.24 4.24l-7.07-7.07l9.9-9.9l4.24 4.25L13.4 12l-2.8-2.83zm5.65-5.66l-2.83 2.83L12 4.93L16.24.69l7.07 7.07l-9.9 9.9l-4.24-4.25L10.6 12l2.82 2.83l7.08-7.07l-4.25-4.25z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkList: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 5h20v2H2zm0 6h20v2H2zm20 6H2v2h20z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkListActive: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M22 4H2v4h20zM2 10h20v4H2zm0 6h20v4H2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkLiveActivity: Icon = {
  "body": "<g fill=\"currentColor\"><path fill-rule=\"evenodd\" d=\"M14.9 1.39A11.01 11.01 0 0 0 1 12a11 11 0 1 0 21.6-2.93c-.54.4-1.16.71-1.83.9A9.02 9.02 0 0 1 12 21a9 9 0 1 1 2-17.78c.19-.67.5-1.29.9-1.83\" clip-rule=\"evenodd\"/><path d=\"M23 4.67a3.67 3.67 0 1 1-7.34 0a3.67 3.67 0 0 1 7.34 0m-10 6.92V6h-2v6.41l4.3 4.3l1.41-1.42l-3.7-3.7Z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkLiveActivityActive: Icon = {
  "body": "<g fill=\"currentColor\"><path fill-rule=\"evenodd\" d=\"M19.333 10.167a5.48 5.48 0 0 0 3.277-1.082c.254.928.39 1.906.39 2.915c0 6.075-4.925 11-11 11S1 18.075 1 12S5.925 1 12 1c1.01 0 1.987.136 2.915.39a5.48 5.48 0 0 0-1.082 3.277a5.5 5.5 0 0 0 5.5 5.5m-6.33-4.172v5.586l3.707 3.707l-1.414 1.414l-4.293-4.293V5.995z\" clip-rule=\"evenodd\"/><path d=\"M23 4.667a3.667 3.667 0 1 1-7.333 0a3.667 3.667 0 0 1 7.333 0\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkLock: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M12 3a4 4 0 0 0-4 4v1H6V7a6 6 0 1 1 12 0v1h-2V7a4 4 0 0 0-4-4m1 15v-4h-2v4z\"/><path fill-rule=\"evenodd\" d=\"M21 10v12H3V10zM5 12v8h14v-8z\" clip-rule=\"evenodd\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkLockActive: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M8 7a4 4 0 1 1 8 0v1h2V7A6 6 0 0 0 6 7v1h2z\"/><path fill-rule=\"evenodd\" d=\"M21 22V10H3v12zm-8-8v5h-2v-5z\" clip-rule=\"evenodd\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkLogout: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M3 3h11v4h-2V5H5v14h7v-2h2v4H3z\"/><path d=\"M19.87 7h-2.4l2.66 4H9v2h11.13l-2.67 4h2.4l3.34-5z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkLongread: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4 10v5h5v-5zm7 1.618V17H2v-7H0V8h11v1.382l1-.5l1 .5V8h11v2h-2v7h-9v-5.382l-1-.5zm4 1V15h5v-5h-5z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkLongreadActive: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11 11.618V17H2v-7H0V8h11v1.382l1-.5l1 .5V8h11v2h-2v7h-9v-5.382l-1-.5z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkLyn: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6 12L7 1h12l-6 11h5L8 23l2-11z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMat: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9 0H7v7H6V0H4v10l3 1.5V24h2V11.5l3-1.5V0h-2v7H9zm6 3.5C15.5 0 20 0 20 0v24h-2V12h-4s.5-5 1-8.5\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMedia404Notfound: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m9.592 8.277l-.898-1.384l3.46-2.247l.898 1.384zm-.485 2.282l-.899-1.384l-.898-1.384l-.9-1.383l1.385-.9l3.46-2.246l1.383-.899l.9 1.384l.898 1.384l.899 1.384l-1.384.899l-3.46 2.247zm4.47 4.063l1.697.865l-.1-1.903l-.188-3.61l-.1-1.902l-1.598 1.038l-3.032 1.968l-1.598 1.038l1.698.865zm-.1-1.903l-.09-1.707l-1.433.931zm4.258-.755h2.475v8.251h-2.475zm4.125-1.65v11.551h-5.775v-11.55zm-13.652.698l-3.76 10.922l-1.56-.537l3.76-10.922zm2.513 9.203a2.063 2.063 0 1 0 0-4.125a2.063 2.063 0 0 0 0 4.125m3.713-2.063a3.713 3.713 0 1 1-7.425 0a3.713 3.713 0 0 1 7.425 0\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaAgelimit12: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9.76 17.3H7.72V8.926a6.4 6.4 0 0 1-2.19.844L5.2 8.14a15 15 0 0 0 1.5-.5q.72-.305 1.43-.63l.73-.36h.9zm1.94 0l-.28-1.16c.6-.5 1.15-.99 1.66-1.44a20 20 0 0 0 2.42-2.56c.29-.4.5-.79.66-1.16c.15-.38.22-.75.22-1.1c0-.28-.04-.52-.13-.74c-.08-.22-.21-.4-.4-.55c-.17-.16-.4-.29-.65-.37a3.1 3.1 0 0 0-.92-.12a4.9 4.9 0 0 0-2.56.74l-.21-1.59a6.8 6.8 0 0 1 3.03-.75c.66 0 1.23.08 1.72.22c.5.15.9.35 1.22.62q.48.39.72.93c.16.35.24.74.24 1.16c0 .38-.07.78-.2 1.18q-.21.626-.55 1.19c-.23.38-.5.77-.81 1.15c-.637.76-1.34 1.463-2.1 2.1q-.411.345-.807.65h4.747l-.24 1.6z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaAgelimit15: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9.76 17.35H7.72V8.98c-.7.44-1.38.69-2.19.84L5.2 8.19c.5-.14 1-.3 1.5-.5l.7-.3l.72-.33l.74-.36h.9zm4.31-1.44c.53 0 .98-.06 1.34-.18c.37-.12.64-.32.82-.59c.2-.27.29-.63.29-1.09c0-.21-.03-.4-.1-.57a1.1 1.1 0 0 0-.3-.45a1.5 1.5 0 0 0-.55-.33q-.345-.15-.87-.24c-.35-.07-.76-.13-1.24-.17c-.55-.04-1.1-.07-1.65-.07l.5-5.52h6.1l-.3 1.65h-4.24l-.23 2.42c.4.02.77.06 1.11.1c.61.07 1.22.2 1.81.38c.5.14.89.35 1.19.61c.3.25.51.55.64.92q.21.525.21 1.2a3.4 3.4 0 0 1-.5 1.87a3.2 3.2 0 0 1-1.5 1.23c-.65.28-1.49.42-2.5.42c-.79-.01-1.57-.12-2.34-.3l-.2-1.65l.9.2c.53.09 1.07.14 1.61.16\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaAgelimit18: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6.13 9.88A6 6 0 0 0 8.33 9v8.45h2.05V6.76h-.9l-.74.36l-.72.33l-.72.3q-.736.29-1.5.5z\"/><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.38 17.1c.757.33 1.574.5 2.4.5a5.7 5.7 0 0 0 2.22-.39c.63-.27 1.12-.64 1.46-1.1c.35-.47.53-1 .53-1.6c0-.38-.06-.7-.18-.98c-.12-.29-.3-.55-.52-.75a3 3 0 0 0-.77-.57q-.39-.204-.795-.382q.24-.091.465-.208c.3-.16.57-.34.8-.56a2.43 2.43 0 0 0 .77-1.82c0-.54-.16-.99-.48-1.39c-.32-.39-.78-.7-1.36-.92c-.57-.22-1.23-.33-1.97-.33c-.5 0-.97.05-1.37.15a4.1 4.1 0 0 0-1.07.42c-.31.18-.58.4-.8.65a2.59 2.59 0 0 0-.5 2.57c.106.259.259.496.45.7a3.55 3.55 0 0 0 1.217.845a6 6 0 0 0-.457.225c-.34.17-.63.38-.88.62a2.54 2.54 0 0 0-.8 1.88c0 .37.07.72.19 1.02a2.78 2.78 0 0 0 1.45 1.42m3.062-5.763a4 4 0 0 0 .638-.387q.375-.285.57-.63c.13-.23.2-.49.2-.78c0-.2-.05-.38-.14-.54a1.3 1.3 0 0 0-.4-.46a1.9 1.9 0 0 0-.64-.3a3.2 3.2 0 0 0-1.91.1c-.27.12-.47.29-.59.49s-.18.41-.18.63c0 .2.05.4.16.58c.12.17.28.33.49.5c.2.14.47.28.78.41c.3.136.638.262 1.022.387M14.71 12.63q.203-.127.428-.245l.932.305q.425.15.83.35c.227.104.44.239.63.4c.169.126.308.286.41.47a1 1 0 0 1 .15.54c0 .35-.11.65-.32.89a1.8 1.8 0 0 1-.83.51a3.7 3.7 0 0 1-2.1.05a2 2 0 0 1-.7-.35c-.19-.15-.33-.33-.42-.53s-.14-.42-.14-.67a1.65 1.65 0 0 1 .53-1.24c.17-.18.37-.33.6-.48\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaAgelimit6: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.553 17.369a4.5 4.5 0 0 0 1.49.227v-.001q1.201 0 2.083-.471a3.4 3.4 0 0 0 1.368-1.307q.486-.835.486-1.93q0-1.004-.395-1.718a2.6 2.6 0 0 0-1.155-1.11q-.76-.395-1.869-.395a5 5 0 0 0-.7.046a5 5 0 0 0-.668.136a6 6 0 0 0-.67.198a4 4 0 0 0-.38.15a6 6 0 0 1 .121-.59q.244-.883.67-1.43a2.47 2.47 0 0 1 1.018-.79a3.4 3.4 0 0 1 1.338-.259q.48.006.958.076q.546.072 1.064.259l.258-1.596a7.7 7.7 0 0 0-1.642-.319a6 6 0 0 0-.714-.046q-1.338 0-2.326.486a4.5 4.5 0 0 0-1.626 1.323a6 6 0 0 0-.958 1.961A9 9 0 0 0 8 12.64a8.3 8.3 0 0 0 .152 1.628c.092.48.25.946.471 1.383c.202.391.47.746.79 1.048a3.3 3.3 0 0 0 1.14.67m-.516-4.665v.012q0 .684.091 1.277q.09.593.304 1.049q.228.44.654.7q.425.242 1.064.242q.638 0 1.034-.243q.394-.258.562-.7q.182-.44.182-1.002q0-.654-.197-1.05a1.2 1.2 0 0 0-.608-.592q-.395-.198-1.019-.198q-.303 0-.593.046q-.289.03-.577.121q-.274.077-.532.183a3 3 0 0 0-.365.155\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaAgelimit9: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.1 17.415c.227.018.437.035.63.035v.01c.88 0 1.64-.15 2.28-.47c.65-.32 1.19-.75 1.61-1.3c.43-.56.74-1.21.94-1.94a8.4 8.4 0 0 0 .16-3.94c-.09-.51-.25-.96-.46-1.36a3.25 3.25 0 0 0-1.89-1.7q-.645-.24-1.47-.24a4.24 4.24 0 0 0-2.05.48c-.58.31-1.04.74-1.37 1.29Q8 9.105 8 10.2a3.45 3.45 0 0 0 .39 1.68a2.6 2.6 0 0 0 1.14 1.09a5.04 5.04 0 0 0 3.21.2a9 9 0 0 0 1.032-.353a6 6 0 0 1-.132.613c-.15.57-.37 1.03-.66 1.39c-.28.37-.61.63-1.01.79c-.38.16-.82.24-1.3.24a6 6 0 0 1-2.01-.33l-.25 1.57a8.3 8.3 0 0 0 1.63.32zm3.78-6.082v-.003q0-.675-.09-1.26a3.6 3.6 0 0 0-.3-1.02c-.14-.3-.35-.54-.62-.7a1.94 1.94 0 0 0-1.04-.26c-.43 0-.77.09-1.04.26c-.26.17-.45.4-.58.69s-.19.62-.19 1c0 .42.07.77.2 1.04c.14.26.34.45.6.58c.27.12.6.18 1 .18q.315 0 .6-.03a5 5 0 0 0 1.46-.477\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaAgelimitA: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.6 6.7L7 17.4h2l.91-2.9h3.9l.79 2.9h2.3L13.5 6.7zm2.81 6.3l-.81-3c-.2-.68-.42-1.35-.64-2.03l-.66 2.13l-.91 2.9z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaAirplay: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1 3h22v15h-5.2l-1.3-2H21V5H3v11h4.5l-1.3 2H1zm11 10l-5 8h10z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaAirplayActive: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1 3h22v15h-5.2l-1.3-2H21V5H3v11h4.5l-1.3 2H1zm18 11h-3.8L12 9l-3.2 5H5V7h14zm-7-1l-5 8h10z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaBeamNote: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18.914 3H8v11H3v7h5l2-2V5h8.086l.914.914V14h-5v7h5l2-2V5.086zM8 18.172L7.172 19H5v-3h3zm11 0l-.828.828H16v-3h3z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaBluetooth: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11.707 23.707L10 23v-7.586l-3.293 3.293l-1.414-1.414L10 12.586v-1.172L5.293 6.707l1.414-1.414L10 8.586V1l1.707-.707l6 6v1.414L13.414 12l4.293 4.293v1.414zM12 13.414v7.172L15.586 17zm0-2.828L15.586 7L12 3.414z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaChromecast: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M21 5H3v4H1V3h22v18H13v-2h8zM5 21h2c0-3.552-2.448-6-6-6v2c2.448 0 4 1.552 4 4m6 0H9c0-4.448-3.552-8-8-8v-2c5.552 0 10 4.448 10 10M1 19c1 0 2 1 2 2H1z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaChromecast1: Icon = {
  "body": "<g fill=\"currentColor\"><path fill-rule=\"evenodd\" d=\"M3 5h18v14h-8v2h10V3H1v6h2zm4 16H5c0-2.45-1.55-4-4-4v-2c3.55 0 6 2.45 6 6m2 0h2c0-5.55-4.45-10-10-10v2c4.45 0 8 3.55 8 8\" clip-rule=\"evenodd\"/><path d=\"M3 21c0-1-1-2-2-2v2\" opacity=\".5\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaChromecast2: Icon = {
  "body": "<g fill=\"currentColor\"><path fill-rule=\"evenodd\" d=\"M3 5h18v14h-8v2h10V3H1v6h2zm0 16c0-1-1-2-2-2v2zm6 0h2c0-5.55-4.45-10-10-10v2c4.45 0 8 3.55 8 8\" clip-rule=\"evenodd\"/><path d=\"M7 21H5c0-2.45-1.55-4-4-4v-2c3.55 0 6 2.45 6 6\" opacity=\".5\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaChromecast3: Icon = {
  "body": "<g fill=\"currentColor\"><path fill-rule=\"evenodd\" d=\"M3 5h18v14h-8v2h10V3H1v6h2zm0 16c0-1-1-2-2-2v2zm2 0h2c0-3.55-2.45-6-6-6v2c2.45 0 4 1.55 4 4\" clip-rule=\"evenodd\"/><path d=\"M11 21H9c0-4.45-3.55-8-8-8v-2c5.55 0 10 4.45 10 10\" opacity=\".5\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaChromecastActive: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3 5h18v14h-8v2h10V3H1v6h2zm0 16c0-1-1-2-2-2v2zm2 0h2c0-3.552-2.448-6-6-6v2c2.448 0 4 1.552 4 4m6 0H9c0-4.448-3.552-8-8-8v-2c5.552 0 10 4.448 10 10M5 9.683A12.03 12.03 0 0 1 12.317 17H19V7H5z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaCompleted: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12S5.925 1 12 1s11 4.925 11 11M7 13l1.5-1.5l2 2l5-5L17 10l-6.5 6.5z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaDirekte: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M40 3H0v18h40zM2 19V5h36v14z\" clip-rule=\"evenodd\"/><path fill=\"currentColor\" d=\"M5 9.225v5.817h2.28c1.794 0 2.63-1.12 2.63-2.932c0-1.794-.814-2.885-2.63-2.885zm1.402 1.125h.657c.988 0 1.415.61 1.415 1.794s-.422 1.773-1.415 1.773h-.657zm4.569 4.692h1.36V10.49h-1.36zm-.132-5.852c0 .414.328.687.81.687c.49 0 .81-.273.81-.687s-.325-.69-.81-.69s-.81.273-.81.69m2.804 5.852h1.398v-2.455c0-.61.316-1.006 1.014-1.006c.2 0 .405.017.5.051v-1.167a1.5 1.5 0 0 0-.41-.043c-.66 0-.997.477-1.078.789h-.064v-.72h-1.36zm5.626.085c1.394 0 1.965-.882 1.995-1.5h-1.245c-.034.286-.345.482-.754.482c-.482 0-.835-.333-.835-.853v-.208h2.864v-.503c0-1.33-.853-2.14-2.085-2.14c-1.159 0-2.1.712-2.1 2.14v.43c0 1.424.869 2.152 2.16 2.152m-.84-2.85v-.026c0-.516.324-.861.793-.861s.772.345.772.86v.026zm5.234 1.248l.269-.315l1.159 1.832h1.577l-1.692-2.595l1.581-1.957h-1.522l-1.308 1.795h-.064V8.918h-1.36v6.124h1.36zm4.049-2.966h-.724v1.03h.694v2.157c0 .95.465 1.309 1.628 1.309c.32 0 .635-.03.738-.051v-.989a5 5 0 0 1-.41.017c-.417 0-.613-.136-.613-.533v-1.91h.997v-1.03h-.997V9.433h-1.313zm5.264 4.568c1.393 0 1.964-.882 1.994-1.5h-1.244c-.034.286-.346.482-.755.482c-.481 0-.835-.333-.835-.853v-.208H35v-.503c0-1.33-.852-2.14-2.084-2.14c-1.16 0-2.101.712-2.101 2.14v.43c0 1.424.87 2.152 2.16 2.152m-.84-2.85v-.026c0-.516.324-.861.793-.861s.771.345.771.86v.026z\"/>",
  "width": 40,
  "height": 24,
  "viewBox": "0 0 40 24"
}

export const nrkMediaDirekteGolive: Icon = {
  "body": "<g fill=\"currentColor\"><path fill-rule=\"evenodd\" d=\"M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2S2 6.477 2 12s4.477 10 10 10m12-10c0 6.627-5.373 12-12 12S0 18.627 0 12S5.373 0 12 0s12 5.373 12 12\" clip-rule=\"evenodd\" opacity=\".5\"/><path d=\"M12 17a5 5 0 1 0 0-10a5 5 0 0 0 0 10\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaDirekteNotlive: Icon = {
  "body": "<g fill=\"currentColor\" fill-rule=\"evenodd\"><path d=\"M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2S2 6.477 2 12s4.477 10 10 10m12-10c0 6.627-5.373 12-12 12S0 18.627 0 12S5.373 0 12 0s12 5.373 12 12\" opacity=\".5\"/><path d=\"M12 14a2 2 0 1 0 0-4a2 2 0 0 0 0 4m5-2a5 5 0 1 1-10 0a5 5 0 0 1 10 0\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaDirektetv: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1 3h22v16H1zm2 2v12h18V5zm13 18H8v-2h8zM8 8.5a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaDirektetvActive: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1 3h22v16H1zm5.5 7a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3M8 23h8v-2H8z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaFfw: Icon = {
  "body": "<g fill=\"currentColor\" fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path d=\"m15.33 7l3.5 5l-3.5 5h-3.05l3.5-5l-3.5-5z\"/><path d=\"m9.33 7l3.5 5l-3.5 5H6.28l3.5-5l-3.5-5z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaFfw15sec: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"m18.99 5.85l-1.21 1.62A8 8 0 1 1 12 5h1.58l-2.1 3h2.44l2.8-4l-2.8-4h-2.44l2.1 3H12a10 10 0 1 0 6.99 2.85\"/><path d=\"M10.06 16.25V9.87H9.5c-.76.37-1.43.69-2.26.89l.2 1.04c.55-.12.93-.26 1.31-.49v4.94h1.3Zm3.23-.92c-.49 0-.97-.08-1.51-.22l.12 1.04c.52.12.91.18 1.42.18c1.82 0 2.73-.81 2.73-2.12c0-1.23-.75-1.79-2.97-1.92l.12-1.38h2.54l.19-1.04h-3.7l-.31 3.34c2.24.04 2.8.31 2.8 1.06c0 .79-.5 1.06-1.43 1.06\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaFfw30sec: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"m18.99 5.85l-1.21 1.62A8 8 0 1 1 12 5h1.58l-2.1 3h2.44l2.8-4l-2.8-4h-2.44l2.1 3H12a10 10 0 1 0 6.99 2.85\"/><path d=\"M8.36 15.34c-.4 0-.69-.04-1.24-.17l-.14 1c.47.11 1.11.18 1.64.18c1.64 0 2.57-.69 2.57-1.91c0-.93-.55-1.52-1.53-1.64v-.03c.87-.23 1.4-.86 1.4-1.58c0-.89-.81-1.41-2.15-1.41c-.63 0-1.31.13-1.85.37l.15.94c.52-.22.98-.31 1.37-.31c.85 0 1.17.22 1.17.72c0 .61-.56.97-1.53.97h-.2l-.13.9h.34c1.14 0 1.64.31 1.64.99s-.48.97-1.51.97Zm6.76-5.55c-1.75 0-2.65 1.19-2.65 3.35s.85 3.21 2.57 3.21s2.62-1.13 2.62-3.31s-.84-3.25-2.54-3.25m-.07 5.55c-.89 0-1.25-.67-1.25-2.24s.36-2.31 1.28-2.31s1.26.69 1.26 2.27s-.36 2.28-1.29 2.28\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaFfw5sec: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"m18.99 5.85l-1.21 1.62a8 8 0 0 1 .796 10.085a8 8 0 0 1-9.72 2.801a8 8 0 0 1-4.694-8.96A8 8 0 0 1 12 5h1.58l-2.1 3h2.44l2.8-4l-2.8-4h-2.44l2.1 3H12a10 10 0 1 0 6.99 2.85\"/><path d=\"M10 15.11c.54.14 1.02.22 1.51.22c.93 0 1.43-.27 1.43-1.06c0-.75-.56-1.02-2.8-1.06l.31-3.34h3.7l-.19 1.04h-2.54l-.12 1.38c2.22.13 2.97.69 2.97 1.92c0 1.31-.91 2.12-2.73 2.12c-.51 0-.9-.06-1.42-.18z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaIndexQuaverTiny: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9 2v2H7v6H3V6h2V2z\"/>",
  "width": 12,
  "height": 12,
  "viewBox": "0 0 12 12"
}

export const nrkMediaJumpto: Icon = {
  "body": "<g fill=\"currentColor\" fill-rule=\"evenodd\"><path d=\"M18 9.98C18 7.55 16 5 12.5 5S7 7.55 7 9.98v2.12l3-2.1v2.45l-4 2.8l-4-2.8V10l3 2.1V9.98C5 6.3 8.2 3 12.5 3S20 6.3 20 9.98v5.82h-2z\" clip-rule=\"evenodd\"/><path d=\"M8 20a2 2 0 1 0-4 0a2 2 0 0 0 4 0m6 0a1 1 0 1 0-2 0a1 1 0 0 0 2 0m6 0a1 1 0 1 0-2 0a1 1 0 0 0 2 0\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaMediaComplete: Icon = {
  "body": "<g fill=\"currentColor\" fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path d=\"M12 3a9 9 0 1 0 0 18a9 9 0 0 0 0-18M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12\"/><path d=\"m17.608 9l-7.726 7.726L6 12.093l1.511-1.31l2.476 3.01l6.207-6.207z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaMediaIncomplete: Icon = {
  "body": "<g fill=\"currentColor\"><path fill-rule=\"evenodd\" d=\"M12 3a9 9 0 1 0 0 18a9 9 0 0 0 0-18M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12\" clip-rule=\"evenodd\" opacity=\".5\"/><path d=\"m15.293 7.293l-8 8l1.414 1.414l8-8z\"/><path d=\"m8.707 7.293l8 8l-1.414 1.414l-8-8z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaNext: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m8.746 5l5.116 7l-5.116 7H5.002l5.138-7l-5.138-7zM18 7h-2v10h2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaNy: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1 6.78v9.87h3.19V9.8a5.6 5.6 0 0 1 2.1-.54c1.06 0 1.6.59 1.6 1.76v5.63h3.2V10.2c0-1.32-.27-2.3-.82-2.92c-.55-.63-1.36-.95-2.44-.95c-.71 0-1.37.14-1.97.42a5.6 5.6 0 0 0-1.67 1.19V6.3zm12.88 8.77c.56.63 1.38.95 2.46.95a4.5 4.5 0 0 0 3.45-1.55v.97c0 .86-.21 1.5-.64 1.93c-.42.44-1.14.66-2.15.66c-.63 0-1.27-.08-1.94-.23c-.65-.16-1.25-.35-1.8-.58l.3 2.53a10.1 10.1 0 0 0 3.89.74c1.12 0 2.1-.21 2.92-.62A4.57 4.57 0 0 0 23 16.09V6.3l-3.19.48v6.33a4.06 4.06 0 0 1-1.97.5q-1.56 0-1.56-1.74V6.3l-3.23.48v5.85c0 1.31.28 2.29.83 2.92\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaPause: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10 3H3v18h7zm11 0h-7v18h7z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaPictureInPicture: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10 11v10h13V11zm11 8h-9v-6h9z\" clip-rule=\"evenodd\"/><path fill=\"currentColor\" d=\"M3 17V5h18v4h2V3H1v16h7v-2z\" opacity=\".5\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaPictureInPictureActive: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10 11v10h13V11zm11 8h-9v-6h9z\" clip-rule=\"evenodd\" opacity=\".5\"/><path fill=\"currentColor\" d=\"M3 17V5h18v4h2V3H1v16h7v-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaPlay: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6 2h8l5.5 10L14 22H6l5.5-10z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaPlayFail: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M15.16 19.893L14 22H6l5.16-9.38zM9.317 2l7.841 14.256L19.5 12L14 2z\" clip-rule=\"evenodd\" opacity=\".5\"/><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M17.211 22L6.227 2H8.23l10.984 20z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaPlaylist: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M12 11h10v2H12zm10 6H2v2h20zM12 5h10v2H12z\" opacity=\".3\"/><path d=\"M3.002 4h3.232l2.75 5l-2.75 5H3.002l2.75-5z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaPlaylistAdd: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M17 4v4h-4v2h4v4h2v-4h4V8h-4V4z\"/><path d=\"M1 5h10v2H1zm0 6h10v2H1zm20 6H1v2h20z\" opacity=\".3\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaPlaylistAddLater: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M13 19h9v-2h-9zm-3-6h12v-2H10zm12-6H8V5h14z\" opacity=\".3\"/><path d=\"M2 5h2v12h3.216L6.13 15H8.5l1.63 3l-1.63 3H6.13l1.086-2H2z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaPlaylistAddNext: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M13 5h9v2h-9zm-2 6h11v2H11zm11 6H8v2h14z\" opacity=\".3\"/><path d=\"M8.5 3H6.13l1.086 2H2v14h2V7h3.216L6.13 9H8.5l1.63-3z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaPlaylistAdded: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M2 5h8v2H2zm0 6h8v2H2zm20 6H2v2h20z\" opacity=\".3\"/><path fill-rule=\"evenodd\" d=\"m22.676 5.969l-7.152 6.953L12 9.047l1.511-1.31l2.117 2.252l5.634-5.435z\" clip-rule=\"evenodd\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaPlaylistRemove: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M1 5h10v2H1zm0 6h10v2H1zm20 6H1v2h20z\" opacity=\".3\"/><path d=\"m22.243 6.172l-1.415-1.415L18 7.586l-2.829-2.829l-1.414 1.415L16.586 9l-2.829 2.828l1.415 1.415L18 10.414l2.828 2.829l1.415-1.415L19.414 9z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaPrevious: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m15.254 5l-5.116 7l5.117 7h3.742l-5.138-7l5.138-7zM6 7h2v10H6z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaProgramguide: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1 2.333v17.411l11 3.3l11-3.3V2.334l-1.735-1.157L12 3.957l-9.265-2.78zm11 3.711l-9-2.7v14.912l8 2.4V9.251l2-.6v12.005l8-2.4V3.344zm7 .812l-4 1.2v2.088l4-1.2z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaProgramguideActive: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1 2.333v17.411l10 3V9.251l2-.6v14.093l10-3V2.334l-1.735-1.157L12 3.956l-9.265-2.78zm18 4.523l-4 1.2v2.088l4-1.2z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaQuaver: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M18 5v2h-4v10l-2 2H6v-8h6V5zm-6 8H8v4h3.172l.828-.828z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaQuaverActive: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18 5v2h-4v10l-2 2H6v-8h6V5z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaQuaverOff: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18 5v2h-4v7.034L17.633 22h-2.195L6.318 2h2.195L12 9.648V5zM8 13v4h2.96l.912 2H6v-8h2.224l.912 2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaRwd: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m8.78 7l-3.5 5l3.5 5h3.051l-3.5-5l3.5-5z\" clip-rule=\"evenodd\"/><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m14.78 7l-3.5 5l3.5 5h3.051l-3.5-5l3.5-5z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaRwd15sec: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M12 3h-1.58l2.1-3h-2.44l-2.8 4l2.8 4h2.44l-2.1-3H12a8 8 0 1 1-5.78 2.47L5.01 5.85A10 10 0 1 0 12 3\"/><path d=\"M10.06 16.25V9.87H9.5c-.76.37-1.43.69-2.26.89l.2 1.04c.55-.12.93-.26 1.31-.49v4.94h1.3Zm3.23-.92c-.49 0-.97-.08-1.51-.22l.12 1.04c.52.12.91.18 1.42.18c1.82 0 2.73-.81 2.73-2.12c0-1.23-.75-1.79-2.97-1.92l.12-1.38h2.54l.19-1.04h-3.7l-.31 3.34c2.24.04 2.8.31 2.8 1.06c0 .79-.5 1.06-1.43 1.06\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaRwd30sec: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M12 3h-1.58l2.1-3h-2.44l-2.8 4l2.8 4h2.44l-2.1-3H12a8 8 0 1 1-5.78 2.47L5.01 5.85A10 10 0 1 0 12 3\"/><path d=\"M8.36 15.34c-.4 0-.69-.04-1.24-.17l-.14 1c.47.11 1.11.18 1.64.18c1.64 0 2.57-.69 2.57-1.91c0-.93-.55-1.52-1.53-1.64v-.03c.87-.23 1.4-.86 1.4-1.58c0-.89-.81-1.41-2.15-1.41c-.63 0-1.31.13-1.85.37l.15.94c.52-.22.98-.31 1.37-.31c.85 0 1.17.22 1.17.72c0 .61-.56.97-1.53.97h-.2l-.13.9h.34c1.14 0 1.64.31 1.64.99s-.48.97-1.51.97Zm9.3-2.3c0-2.14-.84-3.25-2.54-3.25s-2.65 1.19-2.65 3.35s.85 3.21 2.57 3.21s2.62-1.13 2.62-3.31m-3.86.06c0-1.59.36-2.31 1.28-2.31s1.26.69 1.26 2.27s-.36 2.28-1.29 2.28s-1.25-.67-1.25-2.24\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaRwd5sec: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M12 3h-1.58l2.1-3h-2.44l-2.8 4l2.8 4h2.44l-2.1-3H12a8 8 0 1 1-5.78 2.47L5.01 5.85A10 10 0 1 0 12 3\"/><path d=\"M10 15.11c.54.14 1.02.22 1.51.22c.93 0 1.43-.27 1.43-1.06c0-.75-.56-1.02-2.8-1.06l.31-3.34h3.7l-.19 1.04h-2.54l-.12 1.38c2.22.13 2.97.69 2.97 1.92c0 1.31-.91 2.12-2.73 2.12c-.51 0-.9-.06-1.42-.18z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaSoundwave: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11 4H9v18h2zm8 3h-2v12h2zM7 8.8H5v8h2zm6 .2h2v8h-2zm8 1.8h2v4h-2zm-18 0H1v4h2z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaSpeed08x: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9.022 17.452q-2.16 0-3.225-1.35q-1.065-1.365-1.065-4.005q0-2.715 1.11-4.155q1.125-1.44 3.315-1.44q2.13 0 3.18 1.38q1.065 1.365 1.065 4.05q0 2.715-1.095 4.125q-1.095 1.395-3.285 1.395m.015-1.68q1.155 0 1.65-.93q.495-.945.495-2.88q0-1.965-.48-2.865q-.48-.915-1.62-.915q-1.155 0-1.65.945q-.48.93-.48 2.91q0 1.965.48 2.85t1.605.885m6.712 1.725q-.585 0-.99-.375q-.39-.39-.39-.96q0-.54.39-.93q.405-.39.99-.39q.57 0 .96.39q.405.39.405.93q0 .57-.405.96q-.39.375-.96.375m6.7-.045a6.1 6.1 0 0 1-2.055-.33q-.915-.345-1.47-.99q-.555-.66-.555-1.605q0-1.005.6-1.665q.615-.66 1.545-1.05q-.795-.36-1.32-.93q-.51-.57-.51-1.485q0-.75.45-1.41t1.32-1.065q.87-.42 2.145-.42q1.14 0 2.01.33t1.365.93q.495.585.495 1.38q0 1.005-.585 1.62a3.5 3.5 0 0 1-1.395.915q.945.42 1.56 1.035q.63.615.63 1.65q0 .885-.525 1.59q-.51.705-1.455 1.11q-.945.39-2.25.39m-1.725-8.085q0 .6.615 1.035q.63.435 1.755.78q.645-.33 1.005-.75t.36-.975q0-.585-.525-.96q-.525-.39-1.455-.39q-.96 0-1.365.405q-.39.39-.39.855m-.42 4.83q0 .72.555 1.17q.555.435 1.59.435q.93 0 1.575-.375t.645-1.14q0-.72-.795-1.155q-.78-.45-2.055-.855q-.705.375-1.11.825t-.405 1.095m7.104 3.105l2.685-3.87l-2.475-3.615l2.085-.525l1.65 2.925l1.53-2.67h2.37l-2.655 3.795l2.67 3.96h-2.355l-1.62-2.715l-1.59 2.715z\"/>",
  "width": 40,
  "height": 24,
  "viewBox": "0 0 40 24"
}

export const nrkMediaSpeed125x: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M7.465 17.302H5.29v-8.25q-.48.285-.99.48t-1.2.345l-.33-1.74q1.035-.255 1.92-.645t1.845-.84h.93zm3.142.195q-.585 0-.99-.375q-.39-.39-.39-.96q0-.54.39-.93q.405-.39.99-.39q.57 0 .96.39q.405.39.405.93q0 .57-.405.96q-.39.375-.96.375m2.725-.195l-.3-1.215q1.56-1.275 2.67-2.34c1.11-1.065 1.305-1.375 1.695-1.995q.585-.945.585-1.815q0-.81-.525-1.275q-.51-.48-1.545-.48q-.705 0-1.365.21q-.66.195-1.185.525l-.225-1.665q.66-.345 1.425-.54q.765-.21 1.665-.21q1.335 0 2.205.39q.885.39 1.305 1.065q.435.66.435 1.5q0 .81-.39 1.65q-.375.825-1.02 1.635q-.63.795-1.425 1.53q-.78.735-1.59 1.335h4.695l-.255 1.695zm10.778-1.53q1.155 0 1.77-.39t.615-1.38q0-.615-.39-.99c-.39-.375-.73-.435-1.41-.555q-1.005-.195-2.88-.225l.525-5.58h6.18l-.315 1.74H23.96l-.21 2.31q1.845.105 2.925.48q1.095.36 1.56 1.035q.48.675.48 1.695q0 1.65-1.14 2.595t-3.42.945q-.645 0-1.185-.075q-.525-.075-1.185-.225l-.195-1.74q.675.165 1.29.27q.615.09 1.23.09m5.26 1.53l2.685-3.87l-2.475-3.615l2.085-.525l1.65 2.925l1.53-2.67h2.37l-2.655 3.795l2.67 3.96h-2.355l-1.62-2.715l-1.59 2.715z\"/>",
  "width": 40,
  "height": 24,
  "viewBox": "0 0 40 24"
}

export const nrkMediaSpeed15x: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11.662 17.228H9.487v-8.25q-.48.285-.99.48t-1.2.345l-.33-1.74q1.035-.255 1.92-.645t1.845-.84h.93zm3.142.195q-.585 0-.99-.375q-.39-.39-.39-.96q0-.54.39-.93q.405-.39.99-.39q.57 0 .96.39q.405.39.405.93q0 .57-.405.96q-.39.375-.96.375m5.109-1.725q1.155 0 1.77-.39t.616-1.38q0-.615-.39-.99c-.39-.375-.73-.435-1.41-.555q-1.005-.195-2.88-.225l.524-5.58h6.18l-.314 1.74h-4.245l-.21 2.31q1.845.105 2.925.48q1.095.36 1.56 1.035q.48.675.48 1.695q0 1.65-1.14 2.595t-3.42.945q-.645 0-1.186-.075q-.525-.075-1.184-.225l-.195-1.74q.675.165 1.29.27q.615.09 1.23.09Zm5.261 1.53l2.684-3.87l-2.474-3.615l2.084-.525l1.65 2.925l1.53-2.67h2.37l-2.655 3.795l2.67 3.96h-2.355l-1.62-2.715l-1.59 2.715z\"/>",
  "width": 40,
  "height": 24,
  "viewBox": "0 0 40 24"
}

export const nrkMediaSpeed1x: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M17.814 17.325h-2.175v-8.25q-.48.285-.99.48t-1.2.345l-.33-1.74q1.035-.255 1.92-.645t1.845-.84h.93zm1.207 0l2.685-3.87l-2.475-3.615l2.085-.525l1.65 2.925l1.53-2.67h2.37l-2.655 3.795l2.67 3.96h-2.355l-1.62-2.715l-1.59 2.715z\"/>",
  "width": 40,
  "height": 24,
  "viewBox": "0 0 40 24"
}

export const nrkMediaSpeed2x: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m12.368 17.4l-.3-1.215q1.56-1.275 2.67-2.34c1.11-1.065 1.305-1.375 1.695-1.995q.585-.945.585-1.815q0-.81-.525-1.275q-.51-.48-1.545-.48q-.705 0-1.365.21q-.66.195-1.185.525l-.225-1.665q.66-.345 1.425-.54q.765-.21 1.665-.21q1.335 0 2.205.39q.885.39 1.305 1.065q.435.66.435 1.5q0 .81-.39 1.65q-.375.825-1.02 1.635q-.63.795-1.425 1.53q-.78.735-1.59 1.335h4.695l-.255 1.695zm7.704 0l2.685-3.87l-2.475-3.615l2.085-.525l1.65 2.925l1.53-2.67h2.37l-2.655 3.795l2.67 3.96h-2.355l-1.62-2.715l-1.59 2.715z\"/>",
  "width": 40,
  "height": 24,
  "viewBox": "0 0 40 24"
}

export const nrkMediaStop: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 3h18v18H3z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaSubtitles: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1 3h22v17H9.773l-1.528 3H6l1.529-3H1zm2 2v13h18V5zm11 11H5v-2h9zm2 0h3v-2h-3z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaSubtitlesActive: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1 3h22v17H1zm4 13h9v-2H5zm14 0h-3v-2h3z\" clip-rule=\"evenodd\"/><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m8.038 19l1.782.908L8.245 23H6z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaSubtitlesUnavailable: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1 3h22v17H9.773l-1.528 3H6l1.529-3H1zm2 2v13h18V5z\" clip-rule=\"evenodd\" opacity=\".5\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaTheater: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M20 10V4h-8V2h10v8zM4 12v8h4v2H2V12z\" opacity=\".5\"/><path fill=\"currentColor\" d=\"M4 5.4V10H2V2h8v2H5.4l5.3 5.3l-1.4 1.4zm6 6.6v10h12V12zm10 2v6h-8v-6z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaTheaterActive: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10 12v10h12V12zm10 2v6h-8v-6z\" opacity=\".5\"/><path fill=\"currentColor\" d=\"M8 6.6L2.7 1.3L1.3 2.7L6.6 8H2v2h8V2H8zM20 10V4h-8V2h10v8zM4 12v8h4v2H2V12z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaTilgjengelighetGeoblocked: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m12.912 1l-.395 1.474L.916 5.284L.522 7.032C3.192 9.193 6.687 10.844 11 12s8.165 1.472 11.557.937l.534-1.712l-8.642-8.233L14.983 1zm3.228 9.99l-1.08-4.654l5.074 4.834a24 24 0 0 1-3.994-.18m-2.133-.342L12.78 5.359L9.072 9.325q1.17.4 2.446.743q1.275.342 2.49.58M7.053 8.556a24 24 0 0 1-3.548-1.842l6.812-1.649zm4.395 5.635L9.088 23h-2.07l2.498-9.327z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaTilgjengelighetIkkelengertilgjengelig: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.626 15.165c-.402.53-.74 1.11-1.002 1.731L.477 14.502l1-1.732zm1.645-1.618a8 8 0 0 1 1.747-.973L2.874 1.514l-1.748.972zM11 12.062a8 8 0 0 1 2 0V4h-2zm3.982.512c.625.251 1.211.58 1.747.973l6.145-11.061l-1.748-.972zm3.392 2.591c.402.53.74 1.11 1.002 1.731l4.147-2.394l-1-1.732zM6.083 19H1v2h22v-2h-5.083a6.002 6.002 0 0 0-11.834 0\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaTilgjengelighetKommer: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M21 12a9 9 0 1 1-18 0a9 9 0 0 1 18 0m-9 11c6.075 0 11-4.925 11-11S18.075 1 12 1S1 5.925 1 12s4.925 11 11 11m1-17v6h-2V6z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaTilgjengelighetSnartutilgjengelig: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.32 12L19 18.63V23H5v-4.38l4.37-4.86l1.32 1.52L7.35 19h9.33L5 5.37V1h14v4.37zm1.65-5L17 4.63V3H7v1.63L9.03 7z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaVideo: Icon = {
  "body": "<g fill=\"currentColor\"><path fill-rule=\"evenodd\" d=\"M1 3h22v18H1zm2 2v14h18V5z\" clip-rule=\"evenodd\"/><path d=\"M12.556 7H9l2.444 5L9 17h3.556L15 12z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaVolume1: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m7.532 17l5 6H15V1h-2.468l-5 6H1v10zM3 9h5.468L13 3.562v16.876L8.468 15H3zm16 0v6h-2V9z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaVolume2: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m12.532 23l-5-6H1V7h6.532l5-6H15v22zM8.468 9H3v6h5.468L13 20.438V3.562zM19 15V9h-2v6zm4-8v10h-2V7z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaVolume3: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m12.532 23l-5-6H1V7h6.532l5-6H15v22zM8.468 9H3v6h5.468L13 20.438V3.562zM19 17V7h-2v10zm4-13v16h-2V4z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMediaVolumeMuted: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m7.532 17l5 6H15V1h-2.468l-5 6H1v10zM3 9h5.468L13 3.562v16.876L8.468 15H3zm18.9 3L24 9.9l-1.4-1.4l-2.1 2.1l-2.1-2.1L17 9.9l2.1 2.1l-2.1 2.1l1.4 1.4l2.1-2.1l2.1 2.1l1.4-1.4z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMening: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M13.222 3H23v10l-4 7h-3l3-7h-5.778zM1 3h9.778v10L7 20H4l3-7H1z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMinus: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5 11h14v2H5z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMore: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M14 18a2 2 0 1 1-4 0a2 2 0 0 1 4 0m0-6a2 2 0 1 1-4 0a2 2 0 0 1 4 0m-2-4a2 2 0 1 0 0-4a2 2 0 0 0 0 4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkMoreActive: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1S1 5.925 1 12s4.925 11 11 11m2-17a2 2 0 1 1-4 0a2 2 0 0 1 4 0m0 6a2 2 0 1 1-4 0a2 2 0 0 1 4 0m0 6a2 2 0 1 1-4 0a2 2 0 0 1 4 0\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkNewChat: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M13 3H1v17h6.529L6 23h2.245l1.528-3H23v-7h-2v5H3V5h10z\" opacity=\".5\"/><path fill-rule=\"evenodd\" d=\"M20 3h-2v3h-3v2h3v3h2V8h3V6h-3z\" clip-rule=\"evenodd\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkNote1: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M18 5v2h-4v10l-2 2H6v-8h6V5zm-6 8H8v4h3.172l.828-.828z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkNote1Off: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18 7V5h-6v4.65L8.51 2h-2.2l9.13 20h2.2L14 14.03V7zM8 17v-4h1.14l-.92-2H6v8h5.87l-.91-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkNote2: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M18.914 3H8v11H3v7h5l2-2V5h8.086l.914.914V14h-5v7h5l2-2V5.086zM8 18.172L7.172 19H5v-3h3zm11 0l-.828.828H16v-3h3z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkOffline: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M15.41 22L6.278 2h2.199l1.427 3.126A17 17 0 0 1 12 5a17.16 17.16 0 0 1 11.95 4.823l-1.389 1.44A15.16 15.16 0 0 0 12 7q-.615 0-1.218.048l1.36 2.98a12.15 12.15 0 0 1 8.295 3.39l-1.385 1.444a10.15 10.15 0 0 0-5.971-2.78l1.568 3.436a7.2 7.2 0 0 1 2.32 1.478l-1.11 1.17L17.608 22zm-8.385-4.96a7.2 7.2 0 0 1 3.124-1.772l.847 1.855a5.2 5.2 0 0 0-2.582 1.356zm1.029-6.36a12.2 12.2 0 0 0-4.491 2.739l1.385 1.443a10.2 10.2 0 0 1 3.941-2.352zM.05 9.823A17.2 17.2 0 0 1 5.958 6.09l.833 1.825a15.2 15.2 0 0 0-5.352 3.348z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkOnline: Icon = {
  "body": "<g fill=\"currentColor\" fill-rule=\"evenodd\"><path d=\"M12 7a15.16 15.16 0 0 0-10.561 4.263L.05 9.823A17.16 17.16 0 0 1 12 5a17.16 17.16 0 0 1 11.95 4.823l-1.389 1.44A15.16 15.16 0 0 0 12 7\"/><path d=\"M12 12.026a10.15 10.15 0 0 0-7.052 2.836l-1.385-1.444A12.15 12.15 0 0 1 12 10.027a12.15 12.15 0 0 1 8.437 3.393l-1.385 1.443A10.15 10.15 0 0 0 12 12.026m.02 4.996a5.17 5.17 0 0 0-3.606 1.457l-1.39-1.439a7.17 7.17 0 0 1 4.996-2.018c1.917 0 3.66.752 4.949 1.973l-1.376 1.452a5.17 5.17 0 0 0-3.573-1.425\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkOpenInNew: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M19 19H5V5h4V3H3v18h18v-6h-2zm0-12.586V11h2V3h-8v2h4.586l-10 10h2.828z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkPerson: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 1a8 8 0 1 0 0 16a8 8 0 0 0 0-16M6 9a6 6 0 1 1 12 0A6 6 0 0 1 6 9M3 23v-4h18v4h-2v-2H5v2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkPlus: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5 11h14v2H5z\"/><path fill=\"currentColor\" d=\"M11 19V5h2v14z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkPoll: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10 3h4v18h-4zM3 13h4v8H3zm18-5h-4v13h4z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkProgress: Icon = {
  "body": "<g fill=\"currentColor\"><circle cx=\"12\" cy=\"12\" r=\"10\" stroke=\"currentColor\" stroke-width=\"2\" opacity=\".3\"/><path fill-rule=\"evenodd\" d=\"M1 12c0 6.075 4.925 11 11 11s11-4.925 11-11S18.075 1 12 1v2a9 9 0 1 1-9 9z\" clip-rule=\"evenodd\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkQuiz: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10.46 15.93v-1.2c0-.77.15-1.45.44-2.03c.3-.6.67-1.14 1.1-1.62c.44-.49.88-.95 1.3-1.4a9 9 0 0 0 1.08-1.3c.31-.44.47-.9.47-1.4a3 3 0 0 0-.82-2.19c-.53-.55-1.45-.82-2.75-.82c-.58 0-1.2.07-1.87.22c-.65.14-1.35.38-2.1.71L7 3.1a8.6 8.6 0 0 1 2.15-.83A10.2 10.2 0 0 1 11.46 2c1.75 0 3.1.41 4.08 1.23c.97.8 1.46 1.88 1.46 3.23c0 .86-.15 1.59-.46 2.19a6.9 6.9 0 0 1-1.16 1.59l-1.35 1.36c-.47.44-.85.93-1.16 1.48c-.3.53-.46 1.17-.46 1.92v.73zm1 6.07c-.48 0-.88-.17-1.2-.52a1.77 1.77 0 0 1-.5-1.26c0-.5.17-.91.5-1.26c.32-.34.72-.52 1.2-.52c.46 0 .86.18 1.18.52c.33.35.49.77.49 1.26c0 .5-.16.91-.49 1.26c-.32.35-.72.52-1.18.52\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkRadioActive: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M16 12a4 4 0 1 1-8 0a4 4 0 0 1 8 0\"/><path fill-rule=\"evenodd\" d=\"M12 19a7 7 0 1 0 0-14a7 7 0 0 0 0 14m0 2a9 9 0 1 0 0-18a9 9 0 0 0 0 18\" clip-rule=\"evenodd\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkRefresh: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11.48 1.5h2.44l2.8 4l-2.8 4h-2.44l2.1-3H12a7 7 0 1 0 5.563 2.75l1.235-1.648A9 9 0 1 1 12 4.5h1.58z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkRefreshExpressive: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M13.985 1.586a1 1 0 0 0-1.638 1.147L13.584 4.5c-2.05-.085-3.958.23-5.594.999c-2.061.97-3.632 2.633-4.465 4.966a9 9 0 1 0 15.88-2.088l-.063-.081a1 1 0 0 0-1.584 1.217a7 7 0 1 1-12.35 1.625c.654-1.828 1.85-3.084 3.433-3.828c1.305-.614 2.908-.895 4.733-.809l-1.227 1.753l-.055.087a1 1 0 0 0 1.63 1.14l.063-.08l2.735-3.907z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkReload: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12.52 1.5h-2.44l-2.8 4l2.8 4h2.44l-2.1-3H12a7 7 0 1 1-5.563 2.75L5.202 7.602A9 9 0 1 0 12 4.5h-1.58z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkReloadExpressive: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10.015 1.586a1 1 0 0 1 1.637 1.147L10.415 4.5c2.05-.086 3.959.23 5.594.999c2.061.969 3.632 2.633 4.466 4.966a9 9 0 1 1-15.88-2.088l.062-.081A1 1 0 0 1 6.241 9.51a7 7 0 1 0 12.35 1.625c-.653-1.827-1.85-3.083-3.433-3.828c-1.304-.613-2.908-.894-4.733-.808l1.227 1.753l.055.087a1 1 0 0 1-1.63 1.14l-.062-.08l-2.736-3.907z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkReorder: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m7 2l6 3.9v2.272l-5-3.25v12.08H6V4.922l-5 3.25V5.9zm9 17.08V7h2v12.08l5-3.25v2.272l-6 3.9l-6-3.9V15.83z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkRotate: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m5.77 8.16l3.61.64h.01l-1.73 1.73l-4.81-.85L2 4.87l1.73-1.72l.63 3.61l1.12-1.12a8.98 8.98 0 0 1 12.72 0q.059.061.11.125q.051.065.11.125c.15.16.3.33.44.5c.09.11.18.23.27.35c.16.22.3.44.44.67l.037.057q.033.047.063.103a9 9 0 0 1 .49 1.02l.02.05c.35.88.56 1.79.63 2.72l-2.04-.29a7.2 7.2 0 0 0-.63-2.1l-.06-.12a7 7 0 0 0-.5-.84q-.026-.029-.05-.065a6.4 6.4 0 0 0-.75-.905a6.995 6.995 0 0 0-9.89 0zm10.25 5.31l4.81.85l.01.01l.85 4.81l-1.73 1.73l-.64-3.61l-1.12 1.12c-3.52 3.51-9.22 3.51-12.73 0l-.24-.27a8.96 8.96 0 0 1-2.37-5.46l2.04.29c.2 1.47.86 2.89 1.99 4.02c.23.23.48.44.73.63c2.74 2.07 6.66 1.87 9.16-.63l1.12-1.12l-3.61-.64z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkSearch: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10 19a9 9 0 1 0 0-18a9 9 0 0 0 0 18m0-2.118a6.882 6.882 0 1 1 0-13.764a6.882 6.882 0 0 1 0 13.764M15.896 19l2.426 4h2.34l-2.427-4z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkSearchActive: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.5 18a8.5 8.5 0 1 0 0-17a8.5 8.5 0 0 0 0 17m0-3a5.5 5.5 0 1 0 0-11a5.5 5.5 0 0 0 0 11m4.205 3l3.032 5h3.51l-3.034-5z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkSettings: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.93 5.35A9 9 0 0 0 3.8 8.28L.9 7.34l-.62 1.9l2.9.95a9 9 0 0 0 0 3.62l-2.9.95l.62 1.9l2.9-.94a9 9 0 0 0 2.13 2.93l-1.8 2.47l1.63 1.18l1.8-2.47c1.03.59 2.2.98 3.44 1.12V24h2v-3.05a8.9 8.9 0 0 0 3.45-1.12l1.8 2.47l1.61-1.18l-1.8-2.47a9 9 0 0 0 2.14-2.93l2.9.94l.62-1.9l-2.9-.95a9 9 0 0 0 0-3.62l2.9-.95l-.62-1.9l-2.9.94a9 9 0 0 0-2.13-2.93l1.8-2.47l-1.63-1.18l-1.8 2.47A8.9 8.9 0 0 0 13 3.05V0h-2v3.05a8.9 8.9 0 0 0-3.45 1.12L5.75 1.7l-1.6 1.18l1.8 2.47zM12 19a7 7 0 1 1 0-14a7 7 0 0 1 0 14m4-7a4 4 0 1 1-8 0a4 4 0 0 1 8 0m-6 0a2 2 0 1 0 4 0a2 2 0 0 0-4 0\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkSettingsActive: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.18 10.19a9 9 0 0 0 0 3.62l-2.9.95l.62 1.9l2.9-.94a9 9 0 0 0 2.13 2.93l-1.8 2.47l1.63 1.18l1.8-2.47c1.03.59 2.2.98 3.44 1.12V24h2v-3.05a8.9 8.9 0 0 0 3.45-1.12l1.8 2.47l1.61-1.18l-1.8-2.47a9 9 0 0 0 2.14-2.93l2.9.94l.62-1.9l-2.9-.95a9 9 0 0 0 0-3.62l2.9-.95l-.62-1.9l-2.9.94a9 9 0 0 0-2.13-2.93l1.8-2.47l-1.63-1.18l-1.8 2.47A8.9 8.9 0 0 0 13 3.05V0h-2v3.05a8.9 8.9 0 0 0-3.45 1.12L5.75 1.7l-1.6 1.18l1.8 2.47A9 9 0 0 0 3.8 8.28L.9 7.34l-.62 1.9zM12 16a4 4 0 1 0 0-8a4 4 0 0 0 0 8m0-2a2 2 0 1 1 0-4a2 2 0 0 1 0 4\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkShow: Icon = {
  "body": "<g fill=\"currentColor\" clip-rule=\"evenodd\"><path d=\"M12 8a4 4 0 1 1 0 8a4 4 0 0 1 0-8m0 2a2 2 0 1 0 0 4a2 2 0 0 0 0-4\"/><path d=\"M12 4c5.091 0 8.2 2.619 10.76 5.618l.24.28v4.204l-.24.28C20.2 17.38 17.092 20 12 20c-5.096 0-8.204-2.66-10.76-5.654l-.24-.28V9.897l.24-.28C3.8 6.62 6.908 4 12 4m0 2c-4.097 0-6.664 1.97-9 4.643v2.678C5.34 16.001 7.908 18 12 18c4.097 0 6.664-1.971 9-4.644v-2.713C18.664 7.97 16.097 6 12 6\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkSleep: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3.725 18.963v-1.26l5.805-7.635H3.89V8.313h8.58v1.26l-5.835 7.635h6l-.405 1.755zm9.837-6.282l-.221-1.242l4.154-4.879H13.43l.207-1.523h6.195l.207 1.36l-3.992 4.747h4.229l-.222 1.537h-6.49Z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkSomeEmail: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.72 6h14.56L12 12.188zM3 18V7.162l9 7.65l9-7.65V18zM1 4v16h22V4z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkSomeEmailExpressive: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4 4a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3zM3 7.302V17a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V7.302l-7.72 6.433a2 2 0 0 1-2.56 0zM19.438 6H4.562L12 12.198z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkSomeEmbed: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.1 22H8.828l3.9-20H15zM5.9 5L1 12l4.9 7h2.272l-4.9-7l4.9-7zm12.202 0l4.9 7l-4.9 7H15.83l4.9-7l-4.9-7z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkSomeFacebook: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M13.387 7.32c0-.788.174-1.187 1.398-1.187h1.535V3.2h-2.347c-2.933 0-4.106 1.957-4.106 4.107v1.76H7.52V12h2.347v8.8h3.52V12h2.585l.348-2.933h-2.933z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkSomeGoogle: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.796 14.333v-2.618h7.211c.066.382.12.763.12 1.265c0 4.364-2.923 7.462-7.33 7.462A7.63 7.63 0 0 1 .16 12.806a7.63 7.63 0 0 1 7.636-7.637c2.062 0 3.786.753 5.117 1.997L10.84 9.162c-.567-.546-1.56-1.178-3.044-1.178c-2.607 0-4.734 2.16-4.734 4.822s2.127 4.821 4.734 4.821c3.022 0 4.157-2.17 4.331-3.294zm13.27-2.6H23.2v2.134h-2.133V16h-2.134v-2.133H16.8v-2.134h2.133V9.6h2.134z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkSomeInstagram: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12 1.734c-2.788 0-3.138.012-4.233.062c-1.092.05-1.839.223-2.492.477a5 5 0 0 0-1.818 1.184a5 5 0 0 0-1.184 1.818c-.254.653-.427 1.4-.477 2.492c-.05 1.095-.062 1.445-.062 4.233s.012 3.138.062 4.233c.05 1.092.223 1.839.477 2.492a5 5 0 0 0 1.184 1.818a5 5 0 0 0 1.818 1.184c.653.254 1.4.427 2.492.477c1.095.05 1.445.062 4.233.062s3.138-.012 4.233-.062c1.092-.05 1.839-.223 2.492-.477c.675-.262 1.247-.613 1.818-1.184s.922-1.143 1.184-1.818c.254-.653.427-1.4.477-2.492c.05-1.095.062-1.445.062-4.233s-.012-3.138-.062-4.233c-.05-1.092-.223-1.839-.477-2.492a5 5 0 0 0-1.184-1.818a5 5 0 0 0-1.818-1.184c-.653-.254-1.4-.427-2.492-.477c-1.095-.05-1.445-.062-4.233-.062m0 1.85c2.741 0 3.066.01 4.148.06c1.001.045 1.545.213 1.907.353c.479.186.82.409 1.18.768s.582.701.768 1.18c.14.362.308.906.353 1.907c.05 1.082.06 1.407.06 4.148s-.01 3.066-.06 4.148c-.045 1.001-.213 1.545-.353 1.907c-.186.479-.409.82-.768 1.18s-.701.582-1.18.768c-.362.14-.906.308-1.907.353c-1.082.05-1.407.06-4.148.06s-3.066-.01-4.148-.06c-1.001-.045-1.545-.213-1.907-.353c-.479-.186-.82-.409-1.18-.768s-.582-.701-.768-1.18c-.14-.362-.308-.906-.353-1.907c-.05-1.082-.06-1.407-.06-4.148s.01-3.066.06-4.148c.045-1.001.213-1.545.353-1.907a3.2 3.2 0 0 1 .768-1.18c.36-.36.701-.582 1.18-.768c.362-.14.906-.308 1.907-.353c1.082-.05 1.407-.06 4.148-.06M6.728 12a5.272 5.272 0 1 1 10.544 0a5.272 5.272 0 0 1-10.544 0M12 15.422a3.422 3.422 0 1 1 0-6.844a3.422 3.422 0 0 1 0 6.844m5.48-7.67a1.232 1.232 0 1 0 0-2.464a1.232 1.232 0 0 0 0 2.464\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkSomePinterest: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8.91 20.978c.468-.759 1.149-1.978 1.398-2.96l.71-2.7c.365.71 1.45 1.308 2.599 1.308c3.42 0 5.888-3.15 5.888-7.065c0-3.757-3.066-6.561-7-6.561C7.598 3 5 6.29 5 9.87c0 1.672.888 3.738 2.308 4.401c.215.103.337.056.384-.15l.109-.442c.072-.288.16-.64.208-.847a.34.34 0 0 0-.074-.327c-.468-.57-.842-1.617-.842-2.59c0-2.504 1.898-4.924 5.131-4.924c2.795 0 4.748 1.897 4.748 4.616c0 3.066-1.551 5.197-3.57 5.197c-1.112 0-1.953-.925-1.682-2.056c.116-.483.27-.978.418-1.46c.27-.872.526-1.7.526-2.325c0-.87-.468-1.599-1.44-1.599c-1.14 0-2.056 1.178-2.056 2.758c0 1 .337 1.682.337 1.682s-1.122 4.757-1.327 5.645c-.224.98-.14 2.361-.038 3.258q.38.15.77.27\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkSomeShare: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m20.602 9l-4.9-7H13.43l4.2 6H12a7 7 0 0 0-7 7v7.293l2-2V15a5 5 0 0 1 5-5h5.63l-4.2 6h2.272z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkSomeShareIos: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M19 12v9H5v-9h2v-2H3v13h18V10h-4v2zM7 3.9L12 1l5 2.9v2.272l-5-2.9l-5 2.9z\"/><path fill=\"currentColor\" d=\"M11 3h2v14h-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkSomeSnapchat: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.406 5.97c-.312.7-.405 1.614-.372 2.863c.009.317.023.618.05 1.051a3 3 0 0 1-.185-.079a1.4 1.4 0 0 0-.61-.13c-.741 0-1.5.487-1.64 1.228c-.145.76.353 1.42 1.403 1.835c.088.035.16.059.326.111c.17.054.25.081.343.117q.107.044.174.075a.4.4 0 0 0 .094.037q-.008.008-.029.054l-.03.064l-.027.059c-.521 1.213-1.628 2.517-3.286 2.79a1.12 1.12 0 0 0-.935 1.165q.013.22.098.42c.305.712 1.155 1.11 2.626 1.381c.048.218.074.327.117.473c.145.493.55.856 1.157.856c.168 0 .284-.018.572-.074l.079-.016l.084-.015c.26-.048.479-.072.722-.072q.3 0 .616.052c.261.044.485.17 1.077.588c1.183.837 1.888 1.163 3.051 1.163l.07-.001l.08-.004l-.004.002c0 .002.019.002.092.003c1.163 0 1.868-.326 3.05-1.163c.316-.223.445-.31.596-.396c.188-.108.34-.168.483-.192q.316-.051.616-.052c.3 0 .549.03.885.095c.223.044.411.067.594.067c.543 0 .983-.329 1.135-.85a6 6 0 0 0 .115-.466c1.471-.27 2.322-.667 2.625-1.375q.087-.203.1-.423a1.12 1.12 0 0 0-.934-1.166c-1.66-.274-2.767-1.579-3.29-2.796l-.05-.107q-.024-.054-.035-.058a4.5 4.5 0 0 1 .614-.235c.166-.053.237-.076.325-.111c.9-.355 1.44-.878 1.426-1.621c-.012-.614-.441-1.11-1.05-1.331a1.8 1.8 0 0 0-.656-.123a1.6 1.6 0 0 0-.673.142l-.076.035c.117-2.014.072-2.982-.325-3.872c-1.136-2.549-3.265-3.488-5.41-3.488h-.061l-.159.002l-.158.001c-2.139 0-4.264.94-5.4 3.487m12.262 5.133q.07 0 .145.03l.025.009q.044.016.064.02a2.7 2.7 0 0 1-.483.236c-.045.018-.1.037-.232.079c-.877.278-1.275.479-1.518 1.052c-.171.405-.114.846.106 1.297c.627 1.454 1.81 2.92 3.684 3.48c-.328.118-.842.249-1.539.357a.72.72 0 0 0-.468.283c-.046.067-.046.067-.074.119c-.06.117-.098.24-.141.415l-.026.113l-.018.08q-.024.115-.044.194l-.124-.022a5.7 5.7 0 0 0-1.161-.122q-.422 0-.852.072c-.33.055-.638.176-.964.363a8 8 0 0 0-.71.469c-.957.678-1.436.899-2.22.899h-.058l-.05-.003l-.129.003c-.783 0-1.262-.221-2.22-.899c-.774-.548-1.117-.74-1.672-.832a5 5 0 0 0-.852-.072a5.3 5.3 0 0 0-1.082.114l-.203.04l-.063-.28l-.026-.114a1.8 1.8 0 0 0-.141-.416l-.026-.047l-.048-.072a.72.72 0 0 0-.468-.283c-.699-.109-1.213-.24-1.541-.357c1.876-.56 3.059-2.027 3.687-3.485c.22-.444.277-.888.105-1.294c-.188-.443-.559-.698-1.087-.904a6 6 0 0 0-.431-.149a4 4 0 0 1-.232-.077c-.265-.105-.395-.17-.459-.2q-.045-.025-.053-.024l.043-.016a.6.6 0 0 1 .177-.049c.422.198.819.304 1.187.304c.282 0 .526-.063.722-.172a.72.72 0 0 0 .37-.67l-.013-.227l-.007-.11l-.008-.136l-.01-.144a31 31 0 0 1-.056-1.16c-.028-1.047.047-1.79.247-2.238c.86-1.93 2.454-2.634 4.085-2.634h.043l.139-.001l.198-.002c1.635 0 3.233.705 4.093 2.635c.282.631.306 1.572.181 3.545l-.003.057l-.025.413a.72.72 0 0 0 .37.672c.177.097.391.158.638.17a2.9 2.9 0 0 0 1.166-.303a.3.3 0 0 1 .062-.006m.234.058q.018.002.023-.014z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkSomeTommelned: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M20.265 5H10v15h2v-5h9.694zM10 22a2 2 0 0 1-2-2V3h12.265a2 2 0 0 1 1.98 1.717l1.429 10A2 2 0 0 1 21.694 17H14v3a2 2 0 0 1-2 2zm-6-6H1v2h5V1H1v2h3z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkSomeTommelnedActive: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 20a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-3h7.694a2 2 0 0 0 1.98-2.283l-1.429-10A2 2 0 0 0 20.265 3H8zm2 0h2v-2h-2zm-6-4H1v2h5V1H1v2h3z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkSomeTommelopp: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M14 4v3h7.694a2 2 0 0 1 1.98 2.283l-1.429 10A2 2 0 0 1 20.265 21H8V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2m6.265 15H10V4h2v5h9.694zM1 6h5v17H1v-2h3V8H1z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkSomeTommeloppActive: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 7V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v3h7.694a2 2 0 0 1 1.98 2.283l-1.429 10A2 2 0 0 1 20.265 21H8zm2-3h2v2h-2zM1 6h5v17H1v-2h3V8H1z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkSomeTwitter: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M22.4 6.594a8.2 8.2 0 0 1-2.262.602a3.85 3.85 0 0 0 1.733-2.112a8 8 0 0 1-2.502.926a4 4 0 0 0-2.877-1.21c-2.177 0-3.938 1.71-3.938 3.82q0 .45.102.87c-3.276-.157-6.18-1.679-8.121-3.993A3.73 3.73 0 0 0 4 7.417c0 1.324.7 2.495 1.758 3.181a3.94 3.94 0 0 1-1.79-.477v.048c0 1.852 1.36 3.393 3.161 3.744c-.33.086-.679.133-1.037.133q-.38 0-.74-.07c.5 1.517 1.957 2.62 3.682 2.652a8.06 8.06 0 0 1-4.895 1.636q-.476-.001-.94-.055a11.27 11.27 0 0 0 6.03 1.726c7.254 0 11.217-5.821 11.217-10.87q0-.25-.012-.493A7.9 7.9 0 0 0 22.4 6.594\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkSomeYoutube: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m9.723 8.799l5.941 3.1l-.731.379z\" clip-rule=\"evenodd\" opacity=\".5\"/><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M21.906 5.516c.66.657.874 2.15.874 2.15S23 9.418 23 11.17v1.642c0 1.753-.22 3.505-.22 3.505s-.215 1.492-.874 2.15c-.754.777-1.59.857-2.063.902l-.142.015c-3.078.219-7.701.226-7.701.226s-5.72-.052-7.48-.218q-.127-.022-.3-.04c-.558-.067-1.432-.17-2.126-.885c-.66-.657-.874-2.15-.874-2.15S1 14.566 1 12.813V11.17c0-1.752.22-3.504.22-3.504s.215-1.493.874-2.15c.755-.777 1.591-.857 2.063-.903q.078-.006.142-.014c3.078-.219 7.696-.219 7.696-.219h.01s4.618 0 7.696.22l.142.014c.472.045 1.309.125 2.063.902M15.664 11.9l-5.94 3.078V8.799z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkSpinner: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12S5.925 1 12 1v2a9 9 0 1 0 9 9z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkStar: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.162 1L8.888 8H1.37L.885 9.493l6.082 4.419l-2.405 7.4l1.14.826l6.294-4.573l6.298 4.577l1.136-.825l-2.406-7.405l6.09-4.424L22.63 8h-7.527L12.83 1zm.834 3.907L13.65 10h5.356l-4.333 3.148l1.655 5.093l-4.332-3.148l-4.333 3.148l1.655-5.093L4.985 10h5.356z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkStarActive: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.162 1L8.888 8H1.37L.885 9.493l6.082 4.419l-2.405 7.4l1.14.826l6.294-4.573l6.298 4.577l1.136-.825l-2.406-7.405l6.09-4.424L22.63 8h-7.527L12.83 1z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkSuperEmojiPoopAngry: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M8.18 6.84c0 .64-.57 1.12-.94 1.3C4.3 7.76 2.61 9.7 2.61 11.8c0 .7.25 1.4.9 2.08A4.42 4.42 0 0 0 1 17.93C1 20.38 2.76 22 4.84 22h13.6c2.93 0 4.56-1.64 4.56-4.4c0-1.69-.86-3.1-2.45-3.95c.63-.69.96-1.43.96-2.37c0-2.2-1.71-4.07-4.1-4.07c-.1 0-.2 0-.3.02l.01-.41C17.12 3.08 13.16 1 8.2 1a7.6 7.6 0 0 0-1.67.17a.84.84 0 0 0-.63 1.06c.12.47.55.72 1.08.64c.26-.04.82-.1 1.22-.1c3.45 0 7.13.95 7.13 4.05c0 .72-.25.91-.25 1.47c0 .48.37.9.84.9c.5 0 .7-.23 1.4-.23a2.25 2.25 0 0 1 2.35 2.28c0 .87-.38 1.52-.94 2.02c-.42.41-.3 1.26.25 1.45c1.37.52 2.2 1.64 2.2 2.89c0 1.62-1.04 2.66-2.73 2.66H4.84c-1.19 0-2.02-.96-2.02-2.33a2.9 2.9 0 0 1 2.2-2.9c.7-.15.88-1.23.3-1.6a1.92 1.92 0 0 1-.87-1.63c0-1.25 1.08-2.43 3-2c1.33-.39 2.49-1.45 2.49-3c0-.71-.3-1.62-1.35-2.66a.88.88 0 0 0-1.24.02a.9.9 0 0 0 .02 1.26c.5.54.81.86.81 1.42\"/><path d=\"m15.37 13.18l1.18.06c.06 0 .06.02.02.07l-.94.76c-.08.07-.1.13-.08.21l.35 1.25c.02.06-.02.1-.1.04l-1.04-.7a.15.15 0 0 0-.19 0l-1.04.7c-.06.04-.08.02-.06-.04l.3-1.25c.03-.08 0-.14-.06-.2l-.93-.77c-.05-.05-.02-.07.02-.07l1.16-.06c.12 0 .16-.02.2-.12l.47-1.23q.03-.06.06 0l.5 1.25c.03.08.08.1.18.1m-7.51.79c.02-.9.67-1.47 1.47-1.47s1.43.58 1.45 1.47a1.4 1.4 0 0 1-1.45 1.48c-.8 0-1.5-.59-1.47-1.48m3.26 4.61c.1-.31.3-.85 1.15-.85c.81 0 1.02.5 1.14.85c.14.38.4.52.73.44c.4-.1.5-.44.43-.8c-.12-.78-.98-1.65-2.3-1.65c-1.33 0-2.19.87-2.31 1.66c-.06.41.08.7.43.79c.26.06.57 0 .73-.44\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkTilgjengelighet: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 9a2 2 0 1 0 0-4a2 2 0 0 0 0 4m-5 3h3v1l-1 5h2l1-5l1 5h2l-1-5v-1h3v-2H7z\"/><path fill=\"currentColor\" d=\"M12 1a11 11 0 1 0 .01 22.01A11 11 0 0 0 12 1m0 20c-4.96 0-9-4.04-9-9s4.04-9 9-9s9 4.04 9 9s-4.04 9-9 9\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkTilgjengelighetHorbarhet: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M16.41 1H9.59L6 4.59v3.37h2V5.41L10.41 3h5.18L18 5.41v5.18l-5 5v3L10.59 21H9.41L8 19.59V18H6v2.41L8.59 23h2.82L15 19.41v-3l5-5V4.59z\"/><path fill=\"currentColor\" d=\"M16 9V6.59L14.41 5h-2.82L10 6.59V11h-.41L8 12.59v2.82L9.59 17H11v-2h-.59l-.41-.41v-1.18l.41-.41H12V7.41l.41-.41h1.18l.41.41V9z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkTilgjengelighetLydtekst: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4 21h3l-1.33 2h2L9 21h11v-7H4zm2-5h12v3H6z\" clip-rule=\"evenodd\"/><path fill=\"currentColor\" d=\"M14 9h-4v2h4zm3-4H7v2h10zm4-4H3v2h18z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkTilgjengelighetSynstolking: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12 20a2 2 0 1 0 0-4a2 2 0 0 0 0 4\"/><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4 16.59v2.82C5.35 20.65 8.38 23 12 23s6.65-2.35 8-3.59v-2.82C18.65 15.35 15.62 13 12 13s-6.65 2.35-8 3.59M12 21c-2.86 0-5.4-1.94-6.57-3c1.17-1.06 3.71-3 6.57-3s5.4 1.94 6.57 3c-1.17 1.06-3.71 3-6.57 3\" clip-rule=\"evenodd\"/><path fill=\"currentColor\" d=\"M14 9h-4v2h4zm3-4H7v2h10zm4-4H3v2h18z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkTilgjengelighetTegnspraak: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M21.41 11h-4.79l.32-1.99l-1.67-2.25l-2.26-.34L4 13.02v5.99L8.07 23h10.34L20 21.41v-1.6l1.4-1.4V17l1.62-1.59v-2.8l-1.62-1.62zm-.38 2.45v1.13l-.44.43H13v1h5.94l.44.45v1.14l-.4.42h-5.99v1h4.59l.44.45v1.13l-.44.43H8.89L6 18.2v-4.13l7.54-5.51l.62.09l.67.91l-.1.6l-3.87 2.86h9.72l.44.45z\"/><path fill=\"currentColor\" d=\"m6.01 3.72l.56-.29l1.08.33l.28.54l-1.41 4.61l7.82-5.78l.62.09l.67.91l-.1.6l1.19 1.61l.66-.49l.36-2.24l-1.67-2.25l-2.26-.33l-3.85 2.85l-.92-1.79l-2.68-.82l-2.01 1.07L2.27 9h2.09z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkTrash: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9 1a2 2 0 0 0-2 2v2H2v2h3v16h14V7h3V5h-5V3a2 2 0 0 0-2-2zm6 4V3H9v2zM7 7h10v14H7zm2 2h2v10H9zm6 0h-2v10h2z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkTrashActive: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9 1a2 2 0 0 0-2 2v2H2v2h3v16h14V7h3V5h-5V3a2 2 0 0 0-2-2zm6 4V3H9v2zM9 9h2v10H9zm6 0h-2v10h2z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkUnlock: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M12 2a4 4 0 0 0-3.92 3.2S8 5.5 8 6H6c0-.5.12-1.2.12-1.2A6 6 0 0 1 18 6v2h-2V6a4 4 0 0 0-4-4m1 16v-4h-2v4z\"/><path fill-rule=\"evenodd\" d=\"M3 10h18v12H3zm2 2v8h14v-8z\" clip-rule=\"evenodd\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkUnlockActive: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"M8.08 5.199A4.002 4.002 0 0 1 16 6v2h2V6A6 6 0 0 0 6.12 4.801S6 5.5 6 6h2c0-.5.08-.801.08-.801\"/><path fill-rule=\"evenodd\" d=\"M21 10H3v12h18zm-8 4v5h-2v-5z\" clip-rule=\"evenodd\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkUpload: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m12 .999l-6 3.9V7.17l5-3.25V16h2V3.921l5 3.25V4.9zm11 20v-2H1v2z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkUserAvatar: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"m15.011 8.248l.739 1.715l1.86.172l-1.404 1.232l.41 1.822l-1.605-.953l-1.605.953l.41-1.822l-1.402-1.232l1.859-.172zm-4.019 2.732a1.987 1.987 0 1 1-3.974 0a1.987 1.987 0 0 1 3.974 0\"/><path fill-rule=\"evenodd\" d=\"M12 2a9 9 0 0 0-9 9v4H1v2h2v5h18v-5h2v-2h-2v-4a9 9 0 0 0-9-9m-7 9a7 7 0 0 1 14 0v9H5z\" clip-rule=\"evenodd\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkUserAvatarExpressive: Icon = {
  "body": "<g fill=\"currentColor\"><path d=\"m15.011 8.248l.74 1.715l1.858.172l-1.403 1.232l.411 1.822l-1.606-.953l-1.605.953l.41-1.822l-1.402-1.232l1.859-.172l.739-1.715Zm-4.019 2.732a1.987 1.987 0 1 1-3.974 0a1.987 1.987 0 0 1 3.974 0\"/><path fill-rule=\"evenodd\" d=\"M12 2a9 9 0 0 0-9 9v4H2a1 1 0 1 0 0 2h1v2a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-2h1a1 1 0 1 0 0-2h-1v-4a9 9 0 0 0-9-9m-7 9a7 7 0 0 1 14 0v8a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1z\" clip-rule=\"evenodd\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkUserLoggedin: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12 3a9 9 0 1 0 0 18a9 9 0 0 0 0-18m0-2C5.925 1 1 5.925 1 12s4.925 11 11 11s11-4.925 11-11S18.075 1 12 1m0 17a6 6 0 0 1-6-6h12a6 6 0 0 1-6 6m3.465-4h-6.93c.692 1.196 1.984 2 3.465 2s2.773-.804 3.465-2\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkUserLoggedinActive: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11s11-4.925 11-11S18.075 1 12 1M6 12a6 6 0 0 0 12 0z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkUserNotloggedin: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3 12a9 9 0 1 1 18 0a9 9 0 0 1-18 0m-2 0C1 5.925 5.925 1 12 1s11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12m5 0a6 6 0 0 0 12 0h-2a4 4 0 0 1-8 0z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkUserNotloggedinActive: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11s11-4.925 11-11S18.075 1 12 1M6 12a6 6 0 0 0 12 0h-2a4 4 0 0 1-8 0z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export const nrkWarning: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.233 1L1 21h22L12.767 1zM12 3.891L19.73 19H4.27zM13.2 16.4a1.2 1.2 0 1 1-2.4 0a1.2 1.2 0 0 1 2.4 0M13 14h-2v-4h2z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}